webpackJsonp([5],{

/***/ "0khR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export I18N_KEY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deps_utils__ = __webpack_require__("fpVW");



// import { MessageBox } from 'element-ui'
// const http = (url, data, config) => {
var http = function http(url, data, method, config) {
  // url = './api/' + url;
  url = location.href.indexOf('test') >= 0 ? url.replace('./', './aishiwei/') : url;
  if (method === 'get' || method === 'GET') {
    if (!!data) {
      url = url + '?' + parseParams(data);
    }
  }
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    Object(__WEBPACK_IMPORTED_MODULE_2__deps_utils__["a" /* c2s */])({
      url: url,
      data: data,
      method: method || 'POST',
      onSuccess: function onSuccess(res) {
        resolve(res);
      },
      onError: function onError(e) {
        reject(e);
      }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ ajaxType: 'none' }, config));
  });
};
var resetForm = function resetForm(form) {
  !!form ? form.resetFields() : null;
};

var removeZero = function removeZero(str) {
  return str.replace(/\b(0+)/gi, '');
};

var parseParams = function parseParams(data) {
  try {
    var tempArr = [];
    for (var i in data) {
      var key = encodeURIComponent(i);
      var value = encodeURIComponent(data[i]);
      tempArr.push(key + '=' + value);
    }
    var urlParamsStr = tempArr.join('&');
    return urlParamsStr;
  } catch (err) {
    return '';
  }
};

var toFix = function toFix(num, len) {
  return isNaN(Number(num)) || !isFinite(Number(num)) ? Number(0).toFixed(len) : Number(num).toFixed(len);
};
var formatDateToSql = function formatDateToSql(data) {
  if (!data) {
    return '';
  }
  var d = new Date(data);
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate();
  var hour = d.getHours();
  var minutes = d.getMinutes();
  var seconds = d.getSeconds();
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
};
var findCurrent = function findCurrent(data) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    http('kbpos-erp-base-api/ScmAperiod/findCurrent', data).then(function (res) {
      resolve(res);
    });
  });
};
var formatDate = function formatDate(fmt, date) {
  if (!date) {
    return '';
  }
  date = new Date(date);
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};
var getToday = function getToday() {
  return [formatDate('yyyy-MM-dd', new Date()), formatDate('yyyy-MM-dd', new Date())];
};
var getMonth = function getMonth() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = new Date(year, month, 0);
  return [year + '-' + (month < 10 ? '0' + month : month) + '-' + '01', year + '-' + (month < 10 ? '0' + month : month) + '-' + day.getDate()];
};
var statistics = function statistics(category, action, optLabel, optValue) {
  var _hmt = window._hmt || [];
  if (window.location.host === 'i.yazuo.com') {
    _hmt.push(['_trackEvent', category, action, Object(__WEBPACK_IMPORTED_MODULE_2__deps_utils__["b" /* getAppData */])('rootDomain').name + '-' + Object(__WEBPACK_IMPORTED_MODULE_2__deps_utils__["b" /* getAppData */])('currentDomain').name, optValue]);
  }
  window._hmt = _hmt;
};
var getCookie = function getCookie(cookieName) {
  var cookie = document.cookie;
  var i = cookie.indexOf(cookieName);
  if (i === -1) {
    return null;
  } else {
    var starti = i + cookieName.length + 1;
    var endi = cookie.indexOf(';', starti);
    if (endi === -1) {
      return cookie.slice(starti);
    } else {
      return cookie.slice(starti, endi);
    }
  }
};
var getDay = function getDay(day) {
  var today = new Date();
  var targetday = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday);
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + '-' + tMonth + '-' + tDate;
};
var doHandleMonth = function doHandleMonth(month) {
  var m = month;
  if (month.toString().length === 1) {
    m = '0' + month;
  }
  return m;
};

var openWaring = function openWaring() {
  Object(__WEBPACK_IMPORTED_MODULE_2__deps_utils__["c" /* jumpTo */])('login');
};

var validateNumber = function validateNumber(value, callback, mes) {
  var reg = new RegExp('^([1-9][0-9]*){1,3}$');
  if (reg.test(value) || value === '') {
    callback();
  } else {
    callback(new Error(mes));
  }
};
var I18N_KEY = ['zh', 'en', 'polish', 'spanish', 'turkish', 'dutch', 'hungary', 'zhtw', 'ptbr', 'germany', 'french', 'italian'];
/* harmony default export */ __webpack_exports__["a"] = ({ http: http, resetForm: resetForm, toFix: toFix, formatDateToSql: formatDateToSql, findCurrent: findCurrent, getMonth: getMonth, getToday: getToday, jumpTo: __WEBPACK_IMPORTED_MODULE_2__deps_utils__["c" /* jumpTo */], formatDate: formatDate, statistics: statistics, getCookie: getCookie, removeZero: removeZero, getDay: getDay, openWaring: openWaring, validateNumber: validateNumber });

/***/ }),

/***/ "20p3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateShareMixin */
/* unused harmony export UP */
/* unused harmony export DOWN */
/* unused harmony export SIGNAL_SHARE */
/* unused harmony export SIGNAL_DIRECTIVE */
/* unused harmony export FLAG_ADD */
/* unused harmony export FLAG_REPLACE */
/* unused harmony export FLAG_REMOVE */
/* unused harmony export FLAG_UPDATE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_symbols__ = __webpack_require__("8hRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_symbol_for__ = __webpack_require__("0s0N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_symbol_for___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_symbol_for__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol__);

















/**
 * 建立组件或模块间通信渠道机制
 * 支持家族树内和被指定管理的组件间传递信息
 * 家族树中传递可以随时被return false中断
 * 通过自定义指令方式
 * 响应式通信
 * 优雅使用方式封装，类似v-model方案
 * payload推荐immutable style，不强行约束
 * channel props可动态改变，所有相关信道注册在beforeDestroy生命周期中统一销毁
 * 可同时绑定多种方式信息传播路径
 * channel命名支持局部作用域，绑定到parent component上，遵循parent生命周期, 带#号是的是全局作用域
 * 所有在channel传递的信息都为指令，类似http请求无状态模式，短接握手
 * @author 13
 */

var Channel = {};
var channelStore = {}; // 信道存储仓库
/* 以channel name为key索引信道信息
  name值为Symbol类型，所有前缀不是#的子组件的channel name都会被注册到父组件上，跟随父组件生命周期销毁
  有两个特殊的channel name: #up/#down默认附加，用于组件家族树信息传播
  带#的channel name为全局信道，一处注册多处生效
  lastPayload为最近一次信道payload，可能来自多方，最近一次broadcast触发
  callbackMap为回调映射, ctor为组件示例，结构如下
  name: {
    lastPayload: undefined,
    callbackMap: new Map([[ctor, {
      handlers: [{
        isBroadcastRecorder: true/false, // true表示这个handler的存在纯粹是为了记录历次broadcast发出的payload，不参与handler执行
        accumulator: undefined, // 基于历次payload的累加结果
        scan: ({ accumulator, currentValue }) => { // 折叠函数
          return currentValue;
        },
        subscribe: () => {} // 注册callback
      }]
    }]])
  }
*/
var UP = '#up';
var DOWN = '#down';
var SIGNAL_SHARE = '_share'; // 共享数据信号
var SIGNAL_DIRECTIVE = 'directive'; // 指令信号
var FLAG_RECEIVE = 'receive'; // share 接收方
var FLAG_PROVIDE = 'provide'; // share提供方
var FLAG_REPLACE = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default()('R'); // replace
var FLAG_UPDATE = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default()('U'); // update
var FLAG_REMOVE = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default()('C'); // remove
var FLAG_ADD = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default()('A'); // add
/**
 * Install method
 * @param {Vue} Vue - Vue
 */
Channel.install = function (Vue) {
  // const extend = Vue.extend
  Vue.mixin({
    props: {
      channel: [String, Array, Object]
    },
    beforeCreate: function beforeCreate() {
      var _this = this;

      /**
       * 获取有效channel值
       */
      var getChannel = function getChannel() {
        var $options = _this.$options;
        var propsData = $options.propsData;
        /**
         * [{
         *  key: '',
         *  channel: '',
         *  depCtor: null,
         *  channelType: 'receive/provide' receive是share接收方，provide是提供方
         * }]
         */
        var shareChannels = _this._shareChannels || []; // 共享信息update/replace专用通道
        // console.log('originChannel', propsData)
        // 支持逗号字符串和array
        var result = propsData && propsData.channel && [].concat(typeof propsData.channel === 'string' ? propsData.channel.split(',') : Array.isArray(propsData.channel) ? propsData.channel : __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_object_values___default()(propsData.channel)) || [];

        // Add share channel
        result = result.concat(shareChannels.map(function (_ref) {
          var channel = _ref.channel;

          return channel;
        }));
        // 去重
        result = [].concat(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_set___default.a(result)));
        return result;
      };
      /**
       * channel经过筛选后的结果
       * @param {Mix} channel - channel
       */
      var getProperChannel = function getProperChannel(channel) {
        var currentChannels = [UP, DOWN].concat(getChannel());
        var channels = []; // 有效信道
        // channel处理
        if (channel === '*') {
          channels = currentChannels;
        } else {
          channels = channels.concat(typeof channel === 'string' ? channel.split(',') : channel);
          // 滤掉未设定的信道
          channels = channels.filter(function (item) {
            return currentChannels.some(function (item2) {
              return item === item2;
            });
          });
        }
        return channels;
      };
      /**
       * 获取对应的global信道名
       * @param {String} name - 信道名
       * @param {Boolean} createOnNill - 空则创建
       */
      var getGlobalName = function getGlobalName(name) {
        var createOnNill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (name.slice(0, 1) === '#') {
          // 全局信道名
          return __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_symbol_for___default()(name);
        } else {
          var hostCtor = _this.$parent || _this; // 如果是root组件，默认将信道注册到自己身上
          var localChannels = hostCtor._localChannels || [];
          var existChannel = localChannels.find(function (_ref2) {
            var localName = _ref2.localName;

            return localName === name;
          });
          if (existChannel) {
            return existChannel.globalName;
          } else {
            // 生成新的全局信道名
            if (createOnNill) {
              existChannel = {
                localName: name,
                globalName: __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_symbol___default()(name)
              };
              localChannels.push(existChannel);
              hostCtor._localChannels = localChannels;
              return existChannel.globalName;
            } else {
              return null;
            }
          }
        }
      };
      // 暴露到ctor上
      this.$getGlobalChannelName = function (name) {
        return getGlobalName(name, false);
      };
      /**
       * 判断name是否为有效信道
       * @param {String} name - 信道名
       */
      this.$isValidChannel = function (name) {
        var currentChannels = [UP, DOWN].concat(getChannel()); // 获取当前信道名，包括up/down两个特殊通道
        return currentChannels.some(function (name2) {
          return name2 === name;
        });
      };
      /**
       * 根据key获取共享channel信息
       * @param {String} key - 共享key值
       */
      this.$getShareChannelByKey = function (key, channelType) {
        var shareChannels = _this._shareChannels;
        return shareChannels.filter(function (item) {
          return item.key === key && (channelType ? item.channelType === channelType : true);
        });
      };
      /**
       * 设置并返回对应的信道
       * @param {String} name - 信道名
       */
      var setupChannel = function setupChannel(name) {
        name = getGlobalName(name);
        var channel = channelStore[name] || {
          lastPayload: undefined,
          callbackMap: new __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_map___default.a()
        };
        var callbackMap = channel.callbackMap;

        if (!callbackMap.has(_this)) {
          callbackMap.set(_this, {
            shared: [], // 共享state
            handlers: [] // 注册回调
          });
        }
        // 指回
        channelStore[name] = channel;
        return channel;
      };
      /**
       * 执行handler
       * 强大一点，同时支持同步和异步返回
       * @param {Object} { handler, payload }
       * @return {Mix} 返回Promise或其它同步数据类型
       */
      var doHandler = function doHandler(_ref3) {
        var ctx = _ref3.ctx,
            handler = _ref3.handler,
            payload = _ref3.payload,
            name = _ref3.name,
            stopPropagation = _ref3.stopPropagation,
            stopImmediatePropagation = _ref3.stopImmediatePropagation;

        if (!handler.isBroadcastRecorder) {
          // 不考虑广播记录员
          // 只响应特定类别的消息
          var supportPayloadTypes = handler.payloadType === '_' ? [SIGNAL_SHARE, SIGNAL_DIRECTIVE] : [handler.payloadType];
          var currentPayloadType = isSharePayload(payload) ? SIGNAL_SHARE : SIGNAL_DIRECTIVE;
          if (supportPayloadTypes.some(function (item) {
            return item === currentPayloadType;
          })) {
            var handlerResult = handler.subscribe.call(ctx, {
              accumulator: handler.accumulator, // 历史累计结果
              payload: payload, // 当前负载
              channel: name, // 信道名
              stopPropagation: stopPropagation,
              stopImmediatePropagation: stopImmediatePropagation
            });
            var currentValue = payload; // 默认scan的当前值为payload，除非handler返回非undefined值了，这时候用返回值替换payload

            if (isPromise(handlerResult)) {
              return new __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default.a(function (resolve) {
                handlerResult.then(function (value) {
                  if (typeof value !== 'undefined') {
                    currentValue = value;
                  }
                  // 重新计算accumulator
                  handler.accumulator = handler.scan({
                    accumulator: handler.accumulator,
                    currentValue: currentValue
                  });
                  // resolve状态
                  resolve();
                }).catch(function () {
                  // 自动阻断broadcast
                  stopPropagation();
                  stopImmediatePropagation();
                  // resolve状态
                  resolve();
                });
              });
            } else {
              return new __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default.a(function (resolve) {
                if (typeof handlerResult !== 'undefined') {
                  currentValue = handlerResult;
                }
                // 重新计算accumulator
                handler.accumulator = handler.scan({
                  accumulator: handler.accumulator,
                  currentValue: currentValue
                });
                // resolve状态
                resolve();
              });
            }
          } else {
            return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default.a.resolve();
          }
        } else {
          return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_promise___default.a.resolve();
        }
      };
      /**
       * 注册信道回调
       */
      // this.$chan = function (args, autoCapture = false) {
      this.$chan = function (args) {
        var _this2 = this;

        args = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({
          subscribe: function subscribe() {},
          scan: function scan(args) {
            return args.currentValue;
          },
          autoCapture: false, // 是否立即执行
          matcher: 'closest', // 缓存捕获的来源，'closest'表示来自于信道最近一个，'Component Name'来自于对应组件名的accumulator，多个相同name会使来源变的不确定，支持filter function，参数为vm, TODO: 不安全的方式
          payloadType: SIGNAL_DIRECTIVE }, args);

        var _args = args,
            subscribe = _args.subscribe,
            otherArgs = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_objectWithoutProperties___default()(_args, ['subscribe']);

        var currentChannels = [UP, DOWN].concat(getChannel()); // 获取当前信道名，包括up/down两个特殊通道
        /**
         * 注册信道
         * @param {String} name - 信道名
         */
        var regCallback = function regCallback(name, _ref4) {
          var subscribe = _ref4.subscribe,
              scan = _ref4.scan,
              autoCapture = _ref4.autoCapture,
              matcher = _ref4.matcher,
              payloadType = _ref4.payloadType;

          var channel = setupChannel(name);
          var callbackMap = channel.callbackMap;
          // 获取对应组件的注册信息
          var currentCallbackItem = callbackMap.get(_this2);
          // 防重
          var handlers = currentCallbackItem.handlers;

          if (!handlers.some(function (handler) {
            return handler.subscribe === subscribe;
          })) {
            // 存储 callback handler
            var newHandler = {
              accumulator: undefined,
              scan: scan,
              subscribe: subscribe,
              payloadType: payloadType
            };
            handlers.push(newHandler);
            // 标准化匹配器
            var newMatcher = normalizeMatcher(matcher);
            // 自动捕获立即执行
            // if (autoCapture && typeof (channel.lastPayload) !== 'undefined') {
            if (autoCapture) {
              // 自执行保证accumulator是空的，当前payload是上次缓存值
              // doHandler(newHandler, channel.lastPayload);
              var payload = void 0;
              /**
               * 获取合适的payload
               * @param {Array} handlers - handlers
               */
              var getProperPayload = function getProperPayload(handlers) {
                var result = void 0;
                var broadcastRecorder = handlers.find(function (_ref5) {
                  var isBroadcastRecorder = _ref5.isBroadcastRecorder;

                  return isBroadcastRecorder;
                });
                if (broadcastRecorder) {
                  result = broadcastRecorder.accumulator;
                }
                return result;
              };
              if (matcher === 'closest') {
                // payload = channel.lastPayload;
                applyWithMatcherOnChannel.call(_this2, {
                  channel: name,
                  matcher: newMatcher,
                  runner: function runner(callbackItem) {
                    var handlers = callbackItem.handlers;

                    payload = getProperPayload(handlers);
                    if (typeof payload !== 'undefined') {
                      return true;
                    }
                  }
                });
              } else if (typeof matcher === 'string' || isFunction(matcher)) {
                /**
                 * name/filter 匹配
                 */
                applyWithMatcherOnChannel.call(_this2, {
                  channel: name,
                  matcher: newMatcher,
                  runner: function runner(callbackItem) {
                    var handlers = callbackItem.handlers;

                    payload = getProperPayload(handlers);
                    return true;
                  }
                });

                // for (let [ctor, value] of callbackMap) {
                //   if (ctor.$options.name === matcher) {
                //     const { handlers } = value;
                //     payload = getProperPayload(handlers);
                //     break;
                //   }
                // }
              }
              if (typeof payload !== 'undefined') {
                // 找到有效值才执行
                // 执行动作
                doHandler({
                  ctx: _this2,
                  handler: newHandler,
                  payload: payload,
                  name: name,
                  stopPropagation: function stopPropagation() {},
                  stopImmediatePropagation: function stopImmediatePropagation() {}
                });
              }
            }
            // 存储matcher
            newHandler.matcher = newMatcher;
          }
          // console.log('$chan', channelStore);
        };
        // 支持多方式绑定
        if (typeof subscribe === 'function') {
          // 注册到当前信道上
          currentChannels.forEach(function (name) {
            regCallback(name, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({
              subscribe: subscribe
            }, otherArgs));
          });
        } else {
          // 文本方式注册
          __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(subscribe).forEach(function (name) {
            if (_this2.$isValidChannel(name)) {
              var channelSubscribe = subscribe[name];
              if (typeof channelSubscribe === 'function') {
                regCallback(name, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({
                  subscribe: channelSubscribe
                }, otherArgs));
              } else {
                regCallback(name, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, otherArgs, channelSubscribe) // 当成单信道配置对象
                );
              }
            } else {
              console.error(name + ' channel can\'t find in this component.');
            }
          });
        }
      };
      /**
       * broadcast recorder register
       * 每个调用$broadcast方法的组件，如果没有broadcastRecorder，都要默认生成一个
       */
      this.$setBroadcastRecorder = function (_ref6) {
        var _this3 = this;

        var _ref6$channel = _ref6.channel,
            channel = _ref6$channel === undefined ? '*' : _ref6$channel,
            _ref6$registMode = _ref6.registMode,
            registMode = _ref6$registMode === undefined ? 'replace' : _ref6$registMode,
            _ref6$recorder = _ref6.recorder,
            recorder = _ref6$recorder === undefined ? function (_ref7) {
          var _ref7$accumulator = _ref7.accumulator,
              accumulator = _ref7$accumulator === undefined ? undefined : _ref7$accumulator,
              _ref7$currentValue = _ref7.currentValue,
              currentValue = _ref7$currentValue === undefined ? undefined : _ref7$currentValue;

          return currentValue; // 默认记录每次触发的负载
        } : _ref6$recorder;

        var channels = getProperChannel(channel); // 有效信道
        if (channels.length) {
          channels.forEach(function (name) {
            var channel = setupChannel(name);
            var callbackMap = channel.callbackMap;
            var currentCallbackItem = callbackMap.get(_this3);
            var handlers = currentCallbackItem.handlers;

            var position = -1;
            if (handlers.some(function (handler, i) {
              if (handler.isBroadcastRecorder) {
                position = i;
                return true;
              }
            })) {
              if (registMode === 'replace') {
                handlers[position].scan = recorder;
              }
            } else {
              handlers.push({
                isBroadcastRecorder: true,
                accumulator: undefined,
                scan: recorder,
                matcher: function matcher() {
                  return true;
                }, // 占位
                subscribe: function subscribe() {} // 什么事都不干
              });
            }
          });
        }
      };
      // $broadcast implementation
      this.$broadcast = function (_ref8) {
        var _this4 = this;

        var _ref8$dispatch = _ref8.dispatch,
            dispatch = _ref8$dispatch === undefined ? '*' : _ref8$dispatch,
            payload = _ref8.payload;

        // 只有具备name的组件才可以发送消息，强约束，便于debug
        var componentName = this.$options.name;
        if (!componentName && !isShareReflectPayload(payload)) {
          console.error(this, 'The component should have name first before broadcast');
          return;
        }
        // 设置broadcastRecorder，有则忽略
        this.$setBroadcastRecorder({
          channel: dispatch,
          registMode: 'ignore'
        });
        // 广播开始
        var channels = getProperChannel(dispatch); // 有效信道
        if (channels.length) {
          channels.forEach(function (name) {
            var channel = setupChannel(name);
            channel.lastPayload = payload; // 保存最近一次payload
            var callbackMap = channel.callbackMap;
            /**
             * 递归模式异步执行家族树
             * @param {String} name - 信道名
             * @param {Array} ctors - Vue组件列表
             */
            var asyncDeepDoer = function () {
              var _ref9 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(name, ctors) {
                var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ctor, currentCallbackItem, stop, _handlers, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, handler, immStop, nextCtors;

                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context.prev = 3;
                        _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(ctors);

                      case 5:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                          _context.next = 47;
                          break;
                        }

                        ctor = _step.value;
                        currentCallbackItem = callbackMap.get(ctor);
                        stop = false;

                        if (!currentCallbackItem) {
                          _context.next = 43;
                          break;
                        }

                        _handlers = currentCallbackItem.handlers;
                        _iteratorNormalCompletion2 = true;
                        _didIteratorError2 = false;
                        _iteratorError2 = undefined;
                        _context.prev = 14;
                        _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(_handlers);

                      case 16:
                        if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                          _context.next = 29;
                          break;
                        }

                        handler = _step2.value;
                        immStop = false;

                        if (immStop) {
                          _context.next = 25;
                          break;
                        }

                        if (!handler.matcher(_this4, payload)) {
                          _context.next = 23;
                          break;
                        }

                        _context.next = 23;
                        return doHandler({
                          ctx: ctor,
                          handler: handler,
                          payload: payload,
                          name: name,
                          stopPropagation: function stopPropagation() {
                            stop = true; // 中止家族树传递
                          },
                          stopImmediatePropagation: function stopImmediatePropagation() {
                            immStop = true; // 中止同级handler执行
                            stop = true; // 中止家族树传递
                          }
                        });

                      case 23:
                        _context.next = 26;
                        break;

                      case 25:
                        return _context.abrupt('break', 29);

                      case 26:
                        _iteratorNormalCompletion2 = true;
                        _context.next = 16;
                        break;

                      case 29:
                        _context.next = 35;
                        break;

                      case 31:
                        _context.prev = 31;
                        _context.t0 = _context['catch'](14);
                        _didIteratorError2 = true;
                        _iteratorError2 = _context.t0;

                      case 35:
                        _context.prev = 35;
                        _context.prev = 36;

                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }

                      case 38:
                        _context.prev = 38;

                        if (!_didIteratorError2) {
                          _context.next = 41;
                          break;
                        }

                        throw _iteratorError2;

                      case 41:
                        return _context.finish(38);

                      case 42:
                        return _context.finish(35);

                      case 43:
                        if (!stop) {
                          nextCtors = [];

                          if (name === UP) {
                            if (ctor.$parent) {
                              nextCtors.push(ctor.$parent);
                            }
                          } else if (name === DOWN) {
                            if (ctor.$children) {
                              nextCtors = nextCtors.concat(ctor.$children);
                            }
                          }
                          if (nextCtors.length) {
                            // no await，多条分路间不需要等待
                            asyncDeepDoer(name, nextCtors);
                          }
                        }

                      case 44:
                        _iteratorNormalCompletion = true;
                        _context.next = 5;
                        break;

                      case 47:
                        _context.next = 53;
                        break;

                      case 49:
                        _context.prev = 49;
                        _context.t1 = _context['catch'](3);
                        _didIteratorError = true;
                        _iteratorError = _context.t1;

                      case 53:
                        _context.prev = 53;
                        _context.prev = 54;

                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }

                      case 56:
                        _context.prev = 56;

                        if (!_didIteratorError) {
                          _context.next = 59;
                          break;
                        }

                        throw _iteratorError;

                      case 59:
                        return _context.finish(56);

                      case 60:
                        return _context.finish(53);

                      case 61:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this4, [[3, 49, 53, 61], [14, 31, 35, 43], [36,, 38, 42], [54,, 56, 60]]);
              }));

              return function asyncDeepDoer(_x2, _x3) {
                return _ref9.apply(this, arguments);
              };
            }();
            if (name === UP || name === DOWN) {
              // 家族树间传递
              var ctors = [];
              if (name === UP) {
                if (_this4.$parent) {
                  ctors.push(_this4.$parent);
                }
              } else if (name === DOWN) {
                if (_this4.$children) {
                  ctors = ctors.concat(_this4.$children);
                }
              }
              asyncDeepDoer(name, ctors);
            } else {
              callbackMap.forEach(function (_ref10, ctor) {
                var handlers = _ref10.handlers;

                if (ctor !== _this4) {
                  // 自己就别响应自己了
                  // 咔咔整
                  var asyncDoer = function () {
                    var _ref11 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
                      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, handler, immStop;

                      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _iteratorNormalCompletion3 = true;
                              _didIteratorError3 = false;
                              _iteratorError3 = undefined;
                              _context2.prev = 3;
                              _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(handlers);

                            case 5:
                              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                                _context2.next = 18;
                                break;
                              }

                              handler = _step3.value;
                              immStop = false;

                              if (immStop) {
                                _context2.next = 14;
                                break;
                              }

                              if (!handler.matcher(_this4, payload)) {
                                _context2.next = 12;
                                break;
                              }

                              _context2.next = 12;
                              return doHandler({
                                ctx: ctor,
                                handler: handler,
                                payload: payload,
                                name: name,
                                stopPropagation: function stopPropagation() {}, // 定点通道互不影响
                                stopImmediatePropagation: function stopImmediatePropagation() {
                                  immStop = true;
                                }
                              });

                            case 12:
                              _context2.next = 15;
                              break;

                            case 14:
                              return _context2.abrupt('break', 18);

                            case 15:
                              _iteratorNormalCompletion3 = true;
                              _context2.next = 5;
                              break;

                            case 18:
                              _context2.next = 24;
                              break;

                            case 20:
                              _context2.prev = 20;
                              _context2.t0 = _context2['catch'](3);
                              _didIteratorError3 = true;
                              _iteratorError3 = _context2.t0;

                            case 24:
                              _context2.prev = 24;
                              _context2.prev = 25;

                              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                              }

                            case 27:
                              _context2.prev = 27;

                              if (!_didIteratorError3) {
                                _context2.next = 30;
                                break;
                              }

                              throw _iteratorError3;

                            case 30:
                              return _context2.finish(27);

                            case 31:
                              return _context2.finish(24);

                            case 32:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this4, [[3, 20, 24, 32], [25,, 27, 31]]);
                    }));

                    return function asyncDoer() {
                      return _ref11.apply(this, arguments);
                    };
                  }();
                  // 不同ctor挂载点多线程执行handlers，互不影响
                  asyncDoer();
                }
              });
            }
            // 广播记录员单独处理，同步方式，不支持异步
            var selfCallbackItem = callbackMap.get(_this4);
            var handlers = selfCallbackItem.handlers;

            var broadcastRecordHandler = handlers.find(function (_ref12) {
              var isBroadcastRecorder = _ref12.isBroadcastRecorder;

              return isBroadcastRecorder;
            });
            broadcastRecordHandler.accumulator = broadcastRecordHandler.scan({
              accumulator: broadcastRecordHandler.accumulator,
              currentValue: payload
            });
          });
        }
      };
      // 重载$emit，支持渠道信息发送
      var $emit = this.$emit;
      this.$emit = function (evt) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        if (evt === '::') {
          return this.$broadcast(args[0]);
        } else {
          return $emit.apply(this, [evt].concat(args));
        }
      };
      // 信道状态共享
      var channelShare = this.$options.channelShare;
      this._initShare = function () {};
      this._destroyShare = function () {};
      if (channelShare) {
        var tempShareRecords = [];
        __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(channelShare).forEach(function (name) {
          var channel = setupChannel(name);
          var optionShared = normalizeOption(channelShare[name], 'key', function () {
            // 被共享的状态key值(包含所有绑定在ctor上的响应数据，如props、data、computed等)
            return {
              reflect: false, // 是否开启被动响应模式，共享接受方可以通过$shareChange方法变更share state
              watchDeep: false, // 是否深度监控
              onChange: function onChange(_ref13) {
                var changeValue = _ref13.changeValue,
                    mode = _ref13.mode,
                    currentValue = _ref13.currentValue;
                // replace模式
                if (mode === FLAG_REPLACE) {
                  return changeValue;
                }
              }
            };
          });
          var callbackMap = channel.callbackMap;

          var currentCallbackItem = callbackMap.get(_this);
          var shared = currentCallbackItem.shared;

          optionShared.forEach(function (_ref14) {
            var key = _ref14.key,
                watchDeep = _ref14.watchDeep,
                reflect = _ref14.reflect,
                onChange = _ref14.onChange;

            if (isPlainObject(onChange)) {
              // 支持对象按增改查罗列
              var originOnChange = onChange;
              onChange = function onChange(args) {
                return originOnChange[args['mode']](args);
              };
            }
            var item = { // 存储共享状态key
              key: key,
              watchDeep: watchDeep,
              watch: function watch() {
                // 监控value值变化，自动emit
                item.unwatch = _this.$watch(key, function (value) {
                  _this.$broadcast({ // 广播共享changed值
                    dispatch: name,
                    payload: {
                      action: SIGNAL_SHARE,
                      key: key,
                      value: value // TODO: 不可变数据？
                    }
                  });
                }, {
                  deep: watchDeep
                });
              },
              /**
               * 注册被动变更handler
               */
              registreflectHandler: function registreflectHandler(channel) {
                // 根据reflect判定是否能被动触发变更
                if (reflect) {
                  _this.$chan({
                    subscribe: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, channel, function (args) {
                      var payload = args.payload;

                      var shareChannelItems = this.$getShareChannelByKey(key, FLAG_PROVIDE); // 动态变更的，需及时判定
                      if (shareChannelItems.some(function (item) {
                        return item.channel === args.channel;
                      })) {
                        var action = payload.action,
                            value = payload.value;

                        var currentValue = this[key];
                        var newValue = onChange({
                          mode: action,
                          changeValue: value,
                          currentValue: currentValue
                        });
                        if (typeof newValue !== 'undefined') {
                          this[key] = newValue;
                        } else {
                          console.warn(key + ' shared state received change signal,but no valid mutation handler');
                        }
                      }
                    })
                  });
                }
              }
            };
            shared.push(item);
            // 临时记录
            tempShareRecords.push(item);
          });
        });
        // 定义shareInit方法, created后执行，beforeCreated时state还没准备好
        this._initShare = function () {
          tempShareRecords.forEach(function (item) {
            item.watch(); // 执行watch
          });
          _this._initShare = null; // 只执行一次
        };
        // 定义shareDestroy方法, beforeDestroy时执行
        this._destroyShare = function () {
          tempShareRecords.forEach(function (item) {
            item.unwatch(); // 执行unwatch
            item.watch = null; // 防止内存泄漏
          });
          _this._destroyShare = null; // 只执行一次
          tempShareRecords = null; // 防止内存泄漏
        };
      }
    },
    created: function created() {
      // this.$watch('channel', function (nv, ov) {
      //   console.info(`Channel prop ${ov} change to ${nv} may lead to $chan bind failure`);
      // });
      // watch shared key，broadcast change
      this._initShare();
    },
    beforeDestroy: function beforeDestroy() {
      var _this5 = this;

      var localChannels = this._localChannels || []; // 本地channel name集合
      // 删除保存的callback句柄
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_symbols___default()(channelStore).forEach(function (name) {
        if (localChannels.some(function (_ref15) {
          var globalName = _ref15.globalName;

          return globalName === name;
        })) {
          // 直接干掉channelCallbackItem
          delete channelStore[name];
        } else {
          // 干掉绑定的handler组
          var channel = channelStore[name];
          var callbackMap = channel.callbackMap;
          callbackMap.delete(_this5);
        }
      });
      delete this._localChannels;
      this._destroyShare(); // 销毁共享状态存在
      var shareChannels = this._shareChannels || [];
      // 清理provide类型的共享channel
      shareChannels.forEach(function (_ref16) {
        var channel = _ref16.channel,
            channelType = _ref16.channelType;

        if (channelType === FLAG_PROVIDE) {
          var channelName = _this5.$getGlobalChannelName(channel);
          if (channelName) {
            // 直接干掉信道
            delete channelStore[channelName];
          }
        }
      });
      this._shareChannels = null; // 释放

      // 销毁channel绑定函数，防内存泄漏
      this.$setBroadcastRecorder = null;
      this.$broadcast = null;
      this.$chan = null;
      this.$getGlobalChannelName = null;
      this.$isValidChannel = null;
    }
  });
  // 定义合并逻辑
  var strategies = Vue.config.optionMergeStrategies;
  var originDataStrategy = strategies.data;
  strategies.data = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    // 交换位置，保证stateShareMixin里data插入优先级大
    if (args[0] && args[0].flag === 'channel') {
      var arg1 = args[1];
      args[1] = args[0];
      args[0] = arg1;
    }
    var fn = originDataStrategy.apply(this, args);
    return fn;
  };
};

/**
 * 共享状态mixin
 * 响应式的
 * 强关联和弱关联，强关联指那些能在初始化过程中找到绑定值的，建立起和ctor直接对应关系，对应的ctor销毁后关系随之断裂
 * 弱关联指那些在初始化过程中没找到绑定值的，模糊关联，后期建立的ctor信息绑定关系可被替换
 * 只有强关联才会自动绑定update/replace change方法
 */
function stateShareMixin(_ref17) {
  var _ref17$channel = _ref17.channel,
      channel = _ref17$channel === undefined ? '' : _ref17$channel,
      _ref17$inject = _ref17.inject,
      inject = _ref17$inject === undefined ? '' : _ref17$inject,
      _ref17$matcher = _ref17.matcher,
      matcher = _ref17$matcher === undefined ? 'closest' : _ref17$matcher;

  var data = function data() {
    return {};
  };
  var created = function created() {};
  var methods = {};
  // channel和inject必须有值
  if (channel && inject) {
    var injectNormalized = normalizeOption(inject, 'from');
    data = function data() {
      var _this6 = this;

      var result = {};
      var isValidChannel = this.$isValidChannel(channel);
      if (isValidChannel) {
        // from：共享来源key，to：当前接收key
        injectNormalized.forEach(function (_ref18) {
          var from = _ref18.from,
              to = _ref18.to,
              defaultValue = _ref18.defaultValue;
          // 每个key值单独寻找，多个key可能分布在多个ctor中存在
          applyWithMatcherOnChannel.call(_this6, {
            channel: channel,
            matcher: normalizeMatcher(matcher),
            runner: function runner(callbackItem, ctor) {
              var shared = callbackItem.shared;

              return shared.some(function (_ref19) {
                var key = _ref19.key,
                    registreflectHandler = _ref19.registreflectHandler;

                if (key === from) {
                  to = to || from;
                  result[to] = ctor[key]; // TODO: // 不可变数据？
                  // 建立共享信道
                  var shareChannel = setShareChannel({
                    provider: ctor,
                    receiver: _this6,
                    key: from
                  });
                  // 强关联auto change
                  registreflectHandler(shareChannel);
                  return true; // 返回true中止遍历
                }
              });
            }
          });
          // 设置默认值
          if (typeof result[from] === 'undefined' && typeof defaultValue !== 'undefined') {
            result[from] = isFunction(defaultValue) ? defaultValue() : defaultValue;
          }
        });
      }
      return result;
    };
    created = function created() {
      var _this7 = this;

      var isValidChannel = this.$isValidChannel(channel);
      if (isValidChannel) {
        this.$chan({
          subscribe: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, channel, function (_ref20) {
            var payload = _ref20.payload;

            if (isSharePayload(payload)) {
              // 如果是共享消息体
              var key = payload.key,
                  value = payload.value;

              if (injectNormalized.some(function (_ref21) {
                var from = _ref21.from;
                // 控制来源消息包含在插入key字段信息内
                return from === key;
              })) {
                if (typeof this[key] !== 'undefined') {
                  this[key] = value; // 同步到本地data里
                }
              }
            }
          }),
          payloadType: SIGNAL_SHARE, // 只响应共享消息体
          matcher: function matcher(ctor, payload) {
            if (isSharePayload(payload)) {
              // 如果是共享消息体
              var key = payload.key; // 判断是否强关联，如果是，必须严格响应来自绑定组件的共享信息传递

              var shareChannelItems = _this7.$getShareChannelByKey(key, FLAG_RECEIVE);
              if (shareChannelItems.length) {
                // 在有共享信道条件下判断来源是否和前面绑定一致
                if (shareChannelItems[0].relCtorId === ctor._uid) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return true;
              }
            } else {
              return true;
            }
          }
        });
      }
    };
    // 附加auto change方法，只针对强关联有效，且分享key开启了reflect === true模式(默认不开启)
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(methods, {
      /**
       * 共享状态变更
       * @param {String} key - 共享key
       * @param {Mix} value - 变更共享值
       * @param {Object|String} [opts = 'R'] - 控制参数，R === replace(直接替换) / U === update(Merge方式)
       */
      $shareStateChange: function $shareStateChange(key, value) {
        var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : FLAG_REPLACE;

        var shareChannelItems = this.$getShareChannelByKey(key, FLAG_RECEIVE);
        if (shareChannelItems.length) {
          // 强关联
          var changeMode = opts;
          if (!isShareReflectFlag(changeMode)) {
            changeMode = opts.changeMode; // 认为是Object
          }
          this.$broadcast({
            dispatch: shareChannelItems[0].channel, // 关联唯一信道
            payload: {
              action: changeMode,
              value: value
            }
          });
        }
      }
    });
  }

  data.flag = 'channel';
  created.flag = 'channel';

  return {
    data: data,
    created: created,
    methods: methods
  };
}
/**
 * 判断a/b类型是否一致
 */
// function isTypeIdentity(a, b) {
//   return Object.prototype.toString.call(a) === Object.prototype.toString.call(b);
// }

var SHARE_CHANNEL_PREFIX = '#_share';
var shareChannelCounts = 0;
/**
 * 设置共享信道信息
 */
function setShareChannel(_ref22) {
  var _ref22$receiver = _ref22.receiver,
      receiver = _ref22$receiver === undefined ? null : _ref22$receiver,
      _ref22$provider = _ref22.provider,
      provider = _ref22$provider === undefined ? null : _ref22$provider,
      _ref22$key = _ref22.key,
      key = _ref22$key === undefined ? '' : _ref22$key;

  shareChannelCounts++;
  var channel = SHARE_CHANNEL_PREFIX + '_' + shareChannelCounts;
  // 设置receiver
  var shareChannels = receiver._shareChannels || [];
  shareChannels.push({
    channel: channel,
    key: key,
    channelType: FLAG_RECEIVE,
    relCtorId: provider._uid // 关联ctorId
  });
  receiver._shareChannels = shareChannels;
  // 设置provider
  shareChannels = provider._shareChannels || [];
  shareChannels.push({
    channel: channel,
    key: key,
    channelType: FLAG_PROVIDE,
    relCtorId: receiver._uid // 关联ctorId
  });
  provider._shareChannels = shareChannels;
  return channel; // 返回channel信道名
}
/**
 * 标准化matcher
 * @param {Mix} matcher - 待标准化matcher
 */
function normalizeMatcher(matcher) {
  if (matcher === 'closest') {
    return function () {
      return true;
    };
  } else if (typeof matcher === 'string') {
    return function (ctor) {
      return ctor.$options.name === matcher;
    };
  } else if (isFunction(matcher)) {
    return function (ctor) {
      for (var _len3 = arguments.length, matcherArgs = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        matcherArgs[_key3 - 1] = arguments[_key3];
      }

      return matcher.apply(undefined, [ctor].concat(matcherArgs)) === true;
    };
  }
  return function () {
    return false;
  };
}
/**
 * 符合matcher执行runner
 * UP/DOWN自带二层含义(限定UP/DOWN传播方向 UP: self -> childern/DOWN: parent -> self)
 * this指向当前ctor
 */
function applyWithMatcherOnChannel(_ref23) {
  var _ref23$channel = _ref23.channel,
      channel = _ref23$channel === undefined ? '' : _ref23$channel,
      _ref23$matcher = _ref23.matcher,
      matcher = _ref23$matcher === undefined ? function () {
    return true;
  } : _ref23$matcher,
      _ref23$runner = _ref23.runner,
      runner = _ref23$runner === undefined ? function () {} : _ref23$runner;

  if (channel) {
    var channelName = this.$getGlobalChannelName(channel);
    if (channelName) {
      var channelItem = channelStore[channelName];
      var callbackMap = channelItem.callbackMap;

      if (channel === UP || channel === DOWN) {
        var walk = function walk(name, ctors) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(ctors), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var ctor = _step4.value;

              if (matcher(ctor) === true) {
                var currentCallbackItem = callbackMap.get(ctor);
                if (currentCallbackItem) {
                  // 在UP/DOWN上有注册
                  if (runner(currentCallbackItem, ctor) === true) {
                    break;
                  }
                }
              }
              var nextCtors = [];
              if (name === UP) {
                if (ctor.$children) {
                  nextCtors = nextCtors.concat(ctor.$children);
                }
              } else if (name === DOWN) {
                if (ctor.$parent) {
                  nextCtors.push(ctor.$parent);
                }
              }
              if (nextCtors.length) {
                walk(name, nextCtors);
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        };
        var ctors = [];
        if (channel === UP) {
          if (this.$children) {
            ctors = ctors.concat(this.$children);
          }
        } else if (channel === DOWN) {
          if (this.$parent) {
            ctors.push(this.$parent);
          }
        }
        // 家族树间执行
        if (ctors.length) {
          walk(channel, ctors);
        }
      } else {
        // 信道点间执行
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(callbackMap.entries()), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _ref24 = _step5.value;

            var _ref25 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref24, 2);

            var ctor = _ref25[0];
            var callbackItem = _ref25[1];

            if (ctor !== this) {
              // 自己就别找自己了
              if (matcher(ctor) === true) {
                if (runner(callbackItem, ctor) === true) {
                  break;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
    }
  }
}
/**
 * 判断是否为函数
 * @param {Mix} args - 待判定的参数
 */
function isFunction(args) {
  if (Object.prototype.toString.call(args) === '[object Function]') {
    return true;
  }
  return false;
}
/**
 * 判断是否为普通对象
 * @param {Mix} args - 待判定的参数
 */
function isPlainObject(args) {
  if (Object.prototype.toString.call(args) === '[object Object]') {
    return true;
  }
  return false;
}
/**
 * 判定mix是否为promise
 * @param {Mix} mix - 混合类型
 */
function isPromise(mix) {
  var isPromise = false;
  // 判断是否为promise
  try {
    var then = mix.then;
    var catch_ = mix.catch;
    if (Object.prototype.toString.call(then) === '[object Function]' && Object.prototype.toString.call(catch_) === '[object Function]') {
      isPromise = true;
    }
  } catch (evt) {}

  return isPromise;
}
/**
 * 判断value是否为share reflect flag
 */
function isShareReflectFlag(value) {
  return [FLAG_ADD, FLAG_REMOVE, FLAG_REPLACE, FLAG_UPDATE].some(function (value2) {
    return value2 === value;
  });
}
/**
 * payload是否为共享反射指令
 */
function isShareReflectPayload(payload) {
  var isTrue = false;
  try {
    isTrue = isShareReflectFlag(payload['action']);
  } catch (evt) {}
  return isTrue;
}

/**
 * payload是否为共享指令
 */
function isSharePayload(payload) {
  // eslint-disable-line
  var isShare = false;
  try {
    isShare = payload['action'] === SIGNAL_SHARE;
  } catch (evt) {}
  return isShare;
}
/**
 * 标准化参数选项
 * @param {Mix} args - 带格式化参数
 * @param {Function} normalizer - 格式器
 */
function normalizeOption(args) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
  var normalizer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (value) {
    return value;
  };

  var options = [];
  if (typeof args === 'string') {
    if (args) {
      options = options.concat(args.split(',').map(function (value) {
        var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, value);
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, normalizer(item), item);
      }));
    }
  } else if (Array.isArray(args)) {
    options = options.concat(args.map(function (value) {
      if (typeof value === 'string') {
        var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key, value);
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, normalizer(item), item);
      } else {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, normalizer(value), {
          value: value
        });
      }
    }));
  } else {
    // Object类型
    options.push(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, normalizer(args), args));
  }
  return options;
}

/* harmony default export */ __webpack_exports__["a"] = (Channel);
/**
 * UP/DOWN有两层概念，第一层是信道名，第二层是传播方向
 * $broadcast里的dispatch如果设定为UP/DOWN除了指定信道名，还指定了传播方向
 * 类似的还包括stateShareMixin里的channel指定
 */


/***/ }),

/***/ "2i04":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4yfQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BASE_PATH */
/* unused harmony export API_DOMAIN */
/* unused harmony export isFunction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return c2s; });
/* unused harmony export ds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUrlQueryValue; });
/* unused harmony export getPlatformName */
/* unused harmony export getDocumentTitle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return setDocumentTitle; });
/* unused harmony export getRequestIgnorePrefix */
/* unused harmony export isDevelop */
/* unused harmony export getProxyPrefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return jumpTo; });
/* unused harmony export sessionStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return localStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAppStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setAppStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAppData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setAppData; });
/* unused harmony export removeAppData */
/* unused harmony export generateID */
/* unused harmony export log */
/* unused harmony export getWindowScrollTop */
/* unused harmony export gotoWinTop */
/* unused harmony export asyncLoadJs */
/* unused harmony export asyncLoadCss */
/* unused harmony export vueCtorTransformer */
/* unused harmony export getCursorPosition */
/* unused harmony export setCursorPosition */
/* unused harmony export appendTextAtCursor */
/* unused harmony export focusAtLast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_merge__ = __webpack_require__("HN2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__env__ = __webpack_require__("m/6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hook__ = __webpack_require__("IrkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store__ = __webpack_require__("Y4FN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui__);










var _this = this;

/**
 * 工具库
 * 引入方式 import utils from '@/deps/utils';
 * @module utils
 */





// import errorCode from './error-code.js'; // 错误码映射

/**
 * @constant
 * @type {String}
 * @default
 */
var BASE_PATH = '/'; // 总是相对于html
var apiDomain = window.API_DOMAIN || '/';
if (apiDomain.slice(-1) !== '/') {
  apiDomain = apiDomain + '/';
}
if (apiDomain !== '/') {
  // 考虑附加请求协议
  if (apiDomain.slice(0, 4) !== 'http') {
    apiDomain = location.protocol + '//' + apiDomain;
  }
}
var API_DOMAIN = apiDomain; // 接口域名
/**
 * 判断value是否为函数类型
 * @param {*} value - The data
 * @return {Boolean} - true/false
 */
var isFunction = function isFunction(value) {
  return Object.prototype.toString.call(value) === '[object Function]';
};
/**
 * 前后端异步通信接口
 * @param {Object} ajaxOptions - axios config
 * @param {Object} options - 自定义配置项
 * @param {Boolean} [options.mask = true] - 请求是否带遮罩
 * @param {String} [options.ajaxType = 'ignore'] - 防止二次提交 ignore(等上次请求完才能发请求)/abort(直接中断上次请求)/none(可发多个相同请求)
 * @param {Boolean} [options.withData = true] - 在ajaxType不等于none时起作用，作为二次提交的判定条件，是否连带提交参数判定
 * @param {Boolean} [options.autoApplyUrlPrefix = true] - 自动附加请求前缀
 * @param {Boolean} [options.silentError = false] - 默认提示错误
 * @param {Boolean} [options.forceMock = false] - 是否强制走本地mock服务
 * @param {Boolean} [options.autoTry = false] - 是否是自动发起的请求尝试
 * @param {Boolean} [options.customCallback = false] - 是否自定义callback
 * @param {Boolean} [options.callbackCoverServer = false] - onError/onCallback是否覆盖server error
 * @return {Promise} Ajax handler
 */
var c2s = function () {
  var ajaxSources = []; // 存储ajax取消token存储
  // https://github.com/axios/axios/issues/265 IE 8-9
  __WEBPACK_IMPORTED_MODULE_10_axios___default.a.interceptors.response.use(function (response) {
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    }
    return response;
  });

  return function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(ajaxOptions) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$mask = _ref2.mask,
          mask = _ref2$mask === undefined ? true : _ref2$mask,
          _ref2$ajaxType = _ref2.ajaxType,
          ajaxType = _ref2$ajaxType === undefined ? 'ignore' : _ref2$ajaxType,
          _ref2$withData = _ref2.withData,
          withData = _ref2$withData === undefined ? true : _ref2$withData,
          _ref2$autoApplyUrlPre = _ref2.autoApplyUrlPrefix,
          autoApplyUrlPrefix = _ref2$autoApplyUrlPre === undefined ? true : _ref2$autoApplyUrlPre,
          _ref2$silentError = _ref2.silentError,
          silentError = _ref2$silentError === undefined ? false : _ref2$silentError,
          _ref2$forceMock = _ref2.forceMock,
          forceMock = _ref2$forceMock === undefined ? false : _ref2$forceMock,
          _ref2$autoTry = _ref2.autoTry,
          autoTry = _ref2$autoTry === undefined ? false : _ref2$autoTry,
          _ref2$customCallback = _ref2.customCallback,
          customCallback = _ref2$customCallback === undefined ? false : _ref2$customCallback,
          _ref2$callbackCoverSe = _ref2.callbackCoverServer,
          callbackCoverServer = _ref2$callbackCoverSe === undefined ? false : _ref2$callbackCoverSe;

      var appMethods, alert, showIndicator, hideIndicator, url, originUrl, apiPrefix, defaultRequestData, data, dataMainKeys, pathPrefixOnDebug, pathPrefix, tempUrl, maskElement, isRefStatic, refElement, cancelSource, style, isIgnore, clearAjaxSource, clearMask, onSuccess, onError, onCallback, getResMessage, ajaxPromise;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              appMethods = getAppStore('methods');
              alert = __WEBPACK_IMPORTED_MODULE_13_element_ui__["Message"]; // 业务层存储alert引用

              showIndicator = appMethods.showIndicator || function () {}; // 显示加载指示器


              hideIndicator = appMethods.hideIndicator || function () {}; // 隐藏加载指示器


              url = ajaxOptions.url;
              originUrl = url; // 保存原始请求地址

              if (autoApplyUrlPrefix && ajaxOptions.url.slice(0, 4) !== 'http') {
                apiPrefix = window.__api_prefix__; // 附加自定义前缀

                if (apiPrefix) {
                  if (apiPrefix.slice(-1) !== '/') {
                    apiPrefix = apiPrefix + '/';
                  }
                  url = apiPrefix + url;
                }
                ajaxOptions.url = API_DOMAIN + url;
              }
              if (ajaxOptions.url.slice(0, 4) === 'http' && typeof ajaxOptions.withCredentials === 'undefined') {
                ajaxOptions.withCredentials = true; // 默认支持跨域cookie
              }
              // 默认post方式
              ajaxOptions.method = ajaxOptions.method || 'post';
              // 返回值默认json
              ajaxOptions.responseType = ajaxOptions.responseType || 'json';
              _context3.next = 12;
              return __WEBPACK_IMPORTED_MODULE_11__hook__["a" /* default */].exe('request@ajax', {});

            case 12:
              getAppData('$defaultRequestHeader') ? ajaxOptions.headers = getAppData('$defaultRequestHeader') : '';
              // 可继承通过setAppData设置的入参
              defaultRequestData = getAppData('$defaultRequestData');

              if (isFunction(defaultRequestData)) {
                defaultRequestData = defaultRequestData(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, ajaxOptions));
              }
              if (!defaultRequestData) {
                // == false的情况
                defaultRequestData = {};
              }
              data = ajaxOptions.data || {
                header: null,
                body: {}
              };
              // 浅覆盖

              if (defaultRequestData && defaultRequestData.header) {
                data.header = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultRequestData.header, data.header);
              }
              // 浅覆盖
              if (defaultRequestData && defaultRequestData.body) {
                data.body = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, defaultRequestData.body, data.body);
              }
              // data过滤string参数类型的前后空格
              dataMainKeys = ['header', 'body'];

              dataMainKeys.forEach(function (k) {
                var typeofStr = Object.prototype.toString.call(data[k]);
                if (typeofStr === '[object Object]') {
                  // 只过滤第一层对象
                  data[k] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data[k]).reduce(function (pv, cv) {
                    var value = data[k][cv];
                    if (typeof value === 'string') {
                      value = value.trim();
                    }
                    pv = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, pv, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({}, cv, value));
                    return pv;
                  }, {});
                }
              });
              pathPrefixOnDebug = forceMock ? 'mock' : getProxyPrefix(); // 测试环境下的请求路径前缀
              // 带有ignoreMock字段的接口不添加mock前缀 zhaoyao

              if (isDevelop() && !ajaxOptions.ignoreMock && ajaxOptions.url.slice(0, 4) !== 'http') {
                // 默认从rap上拉数据
                ajaxOptions.url = '/' + pathPrefixOnDebug + url;
                //
                pathPrefix = getRequestIgnorePrefix();

                if (pathPrefix) {
                  pathPrefix = pathPrefix.split(',');
                  tempUrl = ajaxOptions.url.split('/');

                  tempUrl = tempUrl.filter(function (flagment) {
                    if (pathPrefix.indexOf(flagment) === -1) {
                      return true;
                    }
                  });
                  ajaxOptions.url = tempUrl.join('/');
                }
              } else {
                delete ajaxOptions.ignoreMock;
                delete data.projectId;
              }
              // 重新指回
              ajaxOptions.data = data;

              maskElement = null;
              isRefStatic = false;
              refElement = null;
              cancelSource = __WEBPACK_IMPORTED_MODULE_10_axios___default.a.CancelToken.source();
              // 遮罩处理

              if (mask === true) {
                // 全局遮罩共用一个遮罩
                // 全屏遮罩
                showIndicator();
                maskElement = document.getElementById('app-ajax-global-mask');
                if (!maskElement) {
                  maskElement = document.createElement('div');
                  maskElement.id = 'app-ajax-global-mask';
                  maskElement.className = 'app-ajax-mask app-ajax-global-mask';
                  maskElement.style.display = 'none';
                  maskElement.style.position = 'fixed';
                  maskElement.style.top = '0';
                  maskElement.style.left = '0';
                  maskElement.style.width = '100%';
                  maskElement.style.height = '100%';
                  maskElement.style.zIndex = 10010;
                  // maskElement.style.background = 'red';
                  maskElement.innerHTML = '<div class="app-ajax-mask-inner"></div>';
                  if (document.body) {
                    // Fuck flow
                    document.body.appendChild(maskElement);
                  }
                }
              } else if (mask instanceof __WEBPACK_IMPORTED_MODULE_9__env__["a" /* Vue */]) {
                // 局部遮罩，要求root element拥有定位，否则给予警告
                refElement = mask.$el;
                style = window.getComputedStyle(refElement);

                if (style.position === 'static') {
                  console.warn('被定位element position === static，数据请求过程中可能会产生布局错乱');
                  refElement.style.position = 'relative';
                  isRefStatic = true;
                }
                maskElement = document.createElement('div');
                maskElement.className = 'app-ajax-mask app-ajax-part-mask';
                maskElement.style.display = 'none';
                maskElement.style.position = 'absolute';
                maskElement.style.width = refElement.offsetWidth;
                maskElement.style.height = refElement.offsetHeight;
                refElement.appendChild(maskElement);
                // 关联vue component，destroy后abort请求
                mask.$once('destroyed', function () {
                  cancelSource.cancel('abort');
                });
              }
              if (maskElement) {
                maskElement.style.display = 'block';
              }
              // 重复请求处理
              ajaxOptions.cancelToken = cancelSource.token;

              if (!(ajaxType === 'abort' || ajaxType === 'ignore')) {
                _context3.next = 36;
                break;
              }

              isIgnore = false;

              ajaxSources.some(function (source) {
                if (ajaxOptions.url === source.url && (!withData || withData && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(ajaxOptions.data) === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(source.data))) {
                  // 带请求参数判定和不带请求参数判定
                  if (ajaxType === 'abort') {
                    source.cancel('abort');
                  } else {
                    isIgnore = true;
                  }
                  return true;
                }
              });

              if (!isIgnore) {
                _context3.next = 36;
                break;
              }

              return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject('ignore'));

            case 36:
              // 存储ajax资源
              ajaxSources.push({
                cancel: cancelSource.cancel,
                url: ajaxOptions.url,
                data: ajaxOptions.data,
                cancelToken: ajaxOptions.cancelToken
              });

              // 清理ajax source

              clearAjaxSource = function clearAjaxSource() {
                ajaxSources = ajaxSources.filter(function (source) {
                  return source.cancelToken !== ajaxOptions.cancelToken;
                });
              };
              // 清理mask


              clearMask = function clearMask() {
                if (!ajaxSources.length) {
                  // 没有进行中的xhr才取消遮罩
                  hideIndicator();
                }
                if (maskElement) {
                  if (mask === true) {
                    maskElement.style.display = 'none';
                  } else {
                    if (maskElement.parentNode) {
                      // Fuck flow
                      maskElement.parentNode.removeChild(maskElement);
                    }
                    // 恢复static定位
                    if (isRefStatic && refElement) {
                      refElement.style.position = 'static';
                    }
                  }
                }
              };

              onSuccess = ajaxOptions.onSuccess || function () {};

              onError = ajaxOptions.onError || function () {};

              onCallback = ajaxOptions.onCallback || function () {};

              if (autoTry) {
                // 自动发起的尝试请求不响应用户逻辑
                onSuccess = onError = function onError() {};
              }
              /**
               * 获取返回信息
               */

              getResMessage = function getResMessage(header) {
                if (header) {
                  return header.message || '系统开小差了！';
                } else {
                  return '系统开小差了！';
                }
              };

              ajaxPromise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                /**
                 * axios resolve回调处理
                 * @param {Object} response - 返回响应
                 */
                var axiosResolveCallback = function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                    var data, header, isSilent, userData;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            data = response.data;

                            if (!customCallback) {
                              _context.next = 7;
                              break;
                            }

                            onCallback(data);
                            clearAjaxSource();
                            clearMask();
                            _context.next = 33;
                            break;

                          case 7:
                            if (!(ajaxOptions.responseType === 'json')) {
                              _context.next = 29;
                              break;
                            }

                            header = data;

                            if (!(header.code !== 0 && header.code !== '0')) {
                              _context.next = 23;
                              break;
                            }

                            if (!(header.code === 40405)) {
                              _context.next = 15;
                              break;
                            }

                            window.isLogin = null;
                            window.sessionStorage.clear();
                            jumpTo('/login');
                            return _context.abrupt('return');

                          case 15:
                            isSilent = silentError;

                            if (Object.prototype.toString.call(silentError) === '[object Function]') {
                              isSilent = silentError(data);
                            }
                            if (!isSilent) {
                              // 业务错误自动提示
                              if (alert) {
                                alert({
                                  message: getResMessage(header),
                                  type: 'warn'
                                });
                              } else {
                                window.alert(getResMessage(header));
                              }
                            }
                            header.success = false;
                            onError(data);
                            reject(data);
                            _context.next = 27;
                            break;

                          case 23:
                            if (!!response.headers.token_refresh && response.headers.token_refresh === '1') {
                              userData = JSON.parse(window.sessionStorage.getItem('userData'));

                              userData.token = response.headers.authentication;
                              sessionStorage('userData', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(userData));
                            }
                            header.success = true;
                            onSuccess(data);
                            resolve(data);

                          case 27:
                            _context.next = 31;
                            break;

                          case 29:
                            onSuccess(data);
                            resolve(data);

                          case 31:
                            clearAjaxSource();
                            clearMask();

                          case 33:
                            _context.next = 35;
                            return __WEBPACK_IMPORTED_MODULE_11__hook__["a" /* default */].exe('response@ajax', {
                              data: response,
                              type: 'success'
                            });

                          case 35:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function axiosResolveCallback(_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }();
                /**
                 * reject handler
                 * @param {Object} err - error
                 */
                var axiosRejectCallback = function () {
                  var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(err) {
                    var isSilent, response, _data, header;

                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            isSilent = silentError;

                            if (Object.prototype.toString.call(silentError) === '[object Function]') {
                              isSilent = silentError(err);
                            }
                            if (err.response) {
                              response = err.response;
                              // The request was made and the server responded with a status code
                              // that falls out of the range of 2xx
                              // debug模式下尝试走一遍本地mock服务，用于应对远程服务接口不全的情况

                              _data = null;

                              if (typeof response.data === 'string') {
                                _data = {
                                  code: -1,
                                  message: response.data
                                };
                              } else {
                                _data = response.data || {
                                  code: -1,
                                  message: response.status + ' ' + response.statusText
                                };
                              }
                              header = _data.header;

                              if (isDevelop() && pathPrefixOnDebug !== 'mock') {
                                console.error('提示', '测试服务期接口返回500错误，尝试走本地mock服务重调一次');
                                c2s(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, ajaxOptions, {
                                  url: originUrl
                                }), {
                                  mask: mask,
                                  ajaxType: ajaxType,
                                  withData: withData,
                                  autoApplyUrlPrefix: autoApplyUrlPrefix,
                                  silentError: silentError,
                                  forceMock: true,
                                  autoTry: true
                                }).then(function (response) {
                                  axiosResolveCallback({
                                    data: response
                                  });
                                });
                                if (!isSilent) {
                                  if (alert) {
                                    alert({
                                      message: getResMessage(header),
                                      type: 'warning'
                                    });
                                  } else {
                                    window.alert(getResMessage(header));
                                  }
                                }
                              } else {
                                // if (header.code === 50001 || header.code === '50001') { // 业务错误
                                if (!isSilent) {
                                  if (alert) {
                                    alert({
                                      message: getResMessage(header),
                                      type: 'warning'
                                    });
                                  } else {
                                    window.alert(getResMessage(header));
                                  }
                                }
                                // }
                              }
                            } else if (err.request) {
                              // The request was made but no response was received
                              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                              // http.ClientRequest in node.js
                              console.log(err);
                            } else {
                              // Something happened in setting up the request that triggered an Error
                              console.log('Error', err);
                            }
                            if (callbackCoverServer) {
                              if (customCallback) {
                                onCallback(err);
                              } else {
                                onError(err);
                              }
                              reject(err);
                            }
                            clearAjaxSource();
                            clearMask();

                            // hook响应
                            _context2.next = 8;
                            return __WEBPACK_IMPORTED_MODULE_11__hook__["a" /* default */].exe('response@ajax', {
                              data: err,
                              type: 'warning'
                            });

                          case 8:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));

                  return function axiosRejectCallback(_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }();
                // 执行ajax
                __WEBPACK_IMPORTED_MODULE_10_axios___default()(ajaxOptions).then(function (response) {
                  axiosResolveCallback(response);
                }).catch(function (err) {
                  axiosRejectCallback(err);
                });
              });

              ajaxPromise.catch(function () {});
              return _context3.abrupt('return', ajaxPromise);

            case 47:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}();
/**
 * 封装c2s方法，请求数据缓存层
 * ds === dataset
 * @param {Boolean} [strictMode = false] - 严格模式
 * @param {Boolean} [cache = false] - 是否缓存
 * @param {Boolean} [localstorage = false] - 是否加入本地存储
 * @param {String} [prefer = 'backward'] - backward/forward(走缓存/走接口)
 * @param {Array} [transform = []] - 返回值转换器
 */
var ds = function () {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // localStorage === -1/1 代表按cacheStore从后存，从前存
    var _options$strictMode = options.strictMode,
        strictMode = _options$strictMode === undefined ? false : _options$strictMode,
        _options$cache = options.cache,
        cache = _options$cache === undefined ? false : _options$cache,
        _options$localStorage = options.localStorage,
        localStorage = _options$localStorage === undefined ? false : _options$localStorage;

    var historyLength = 1; // 只保留最近一次数据记录，暂不做可配选项，未发现对应需求
    var prefer = 'backward'; // 优先取历史数据，没取到再走接口，对比forward，直接取值
    var transform = [].concat(options.transform || []); // 变换器
    var url = options.url;
    var cacheStore = []; // 存储响应结果
    var promise = null; // 保留最近一次请求promise
    var lastData = null; // 保留最近一次请求data，用来在兼容模式下判定是否要重新发起请求
    if (!url) {
      console.error('ds配置参数url不能为空');
      return;
    }
    return function (ajaxOptions) {
      var customOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _ajaxOptions$data = ajaxOptions.data,
          data = _ajaxOptions$data === undefined ? {} : _ajaxOptions$data;

      var dataCopy = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, data);
      // 重设请求地址
      ajaxOptions.url = url;
      // 从localStorage里取数据填充内存
      var fillCacheStore = function fillCacheStore() {
        // 只填充一次
        if (fillCacheStore.isFilled || localStorage === false) {
          return;
        }
        var localDs = __WEBPACK_IMPORTED_MODULE_12_store___default.a.get('ds') || [];
        localDs.some(function (item) {
          if (item.url === url) {
            cacheStore = item.cacheStore;
            return true;
          }
        });
        fillCacheStore.isFilled = true;
      };
      var end = function end() {
        // 释放promise引用
        promise = null;
      };
      var doTransform = function doTransform(res) {
        var callTransform = transform.concat(customOptions.transform || []);
        // res流过transform
        res = callTransform.reduce(function (pv, cv) {
          return cv(pv);
        }, res);
        return res;
      };
      var doPromise = function doPromise(resolve, reject) {
        c2s(ajaxOptions, customOptions).then(function (res) {
          res = doTransform(res);
          // 返回值
          var result = {
            res: res
          };
          // 缓储响应数据
          if (cache) {
            if (!cacheStore.some(function (item) {
              if (item.req.url === url && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item.req.data) === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(dataCopy)) {
                item.res.push(res);
                // 保留有限长度
                item.res = item.res.slice(-historyLength);
                return true;
              }
            })) {
              cacheStore.push({
                req: {
                  url: url,
                  data: dataCopy // 保存data copy版防止被完善结构
                },
                res: [res]
              });
            }
            result.cacheStore = cacheStore;
            // 处理本地存储
            if (localStorage !== false) {
              var localDs = __WEBPACK_IMPORTED_MODULE_12_store___default.a.get('ds') || [];
              // 获取待填充的本地数据
              var getLocalDs = function getLocalDs(cacheStore) {
                if (localStorage === true) {
                  return cacheStore;
                } else {
                  if (localStorage > 0) {
                    return cacheStore.slice(0, localStorage);
                  } else {
                    return cacheStore.slice(localStorage);
                  }
                }
              };
              if (!localDs.some(function (item) {
                if (item.url === url) {
                  item.cacheStore = getLocalDs(cacheStore);
                  return true;
                }
              })) {
                // 没找到新加入
                localDs.push({
                  url: url,
                  cacheStore: getLocalDs(cacheStore)
                });
              }
              // 重新存储
              __WEBPACK_IMPORTED_MODULE_12_store___default.a.set('ds', localDs);
            }
          }
          // resolve
          resolve(result);
          end();
        }).catch(function (err) {
          reject(err);
          end();
        });
      };
      if (!cache) {
        // 非缓存模式
        if (strictMode) {
          // 严格模式下，调用几次就发送几次请求
          promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            doPromise(resolve, reject);
          });
        } else {
          // 兼容模式下(strictMode === false)，防止同时多次调用
          if (!promise) {
            promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              doPromise(resolve, reject);
            });
          } else {
            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(lastData) !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(dataCopy)) {
              promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                doPromise(resolve, reject);
              });
            }
          }
        }
      } else {
        // 缓存模式
        fillCacheStore(); // 先填充本地缓存
        var callPrefer = customOptions.prefer || prefer;
        var handlePromise = function handlePromise() {
          if (callPrefer === 'backward') {
            var cacheItem = cacheStore.find(function (item) {
              return item.req.url === url && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item.req.data) === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(dataCopy);
            });
            if (!cacheItem) {
              // 未找到缓存走api请求
              promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                doPromise(resolve, reject);
              });
            } else {
              promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                resolve({
                  res: cacheItem.res[cacheItem.res.length - 1],
                  cacheStore: cacheStore
                });
                end();
              });
            }
          } else if (callPrefer === 'forward') {
            promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              doPromise(resolve, reject);
            });
          }
        };
        if (strictMode) {
          // 严格模式下，各自判定，互相独立
          handlePromise();
        } else {
          // 兼容模式
          if (!promise) {
            // promise不存在，backward/forward分别对待
            handlePromise();
          } else {
            // 兼容模式下，如果promise存在，backward和forward行为一致，取当前promise返回值
            if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(lastData) !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(dataCopy)) {
              promise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                doPromise(resolve, reject);
              });
            }
          }
        }
      }
      lastData = dataCopy; // 保留请求参数引用
      return promise;
    };
  };
}();
/**
 * 获取地址对应查询参数值
 * @param {String} key - Query key
 * @return {String} Value
 */
var getUrlQueryValue = function getUrlQueryValue(key) {
  var search = location.search;
  var value;
  if (search) {
    search.slice(1).split('&').some(function (fragment) {
      var arr = fragment.split('=');
      if (arr[0] === key) {
        value = arr[1];
        return true;
      }
    });
  }
  return value;
};

/**
 * 获取平台名（内部根据platformName参数值判定）
 * @return {String} 平台名
 */
var getPlatformName = function getPlatformName() {
  var platformName = getUrlQueryValue('platformName') || 'pc'; // 默认pc平台
  return platformName;
};

/**
 * 获取页面title（内部根据title query param返回）
 * @return {Stirng} 页面title
 */
var getDocumentTitle = function getDocumentTitle() {
  var title = getUrlQueryValue('title') || ''; // Document title
  return title;
};

/**
 * 设置Document title
 * @param {String} title Document title
 */
var setDocumentTitle = function setDocumentTitle(title) {
  document.getElementsByTagName('title')[0].innerHTML = title;
  window.AlipayJSBridge && window.AlipayJSBridge.call('setTitle', { // 支付宝修改title的方式
    title: title
  });
};

/**
 * 根据ignorePrefix查询参数获取请求需要忽略的访问路径
 * @return {String} 路径
 */
var getRequestIgnorePrefix = function getRequestIgnorePrefix() {
  var pathPrefix = getUrlQueryValue('ignorePrefix') || ''; // 二级目录路径
  return pathPrefix;
};

/**
 * 根据请求参数或者访问地址判断是否处于develop状态
 * 开发环境包括127.0.0.1/localhost/192.168.x.x（不包括192.168.49.61）
 * @return {Boolean} true/false
 */
var isDevelop = function isDevelop() {
  var debugValue = getUrlQueryValue('develop') || '';
  if (debugValue !== '') {
    return !!(debugValue / 1);
  } else {
    // 根据访问地址判断
    var hostname = location.hostname;
    // 本地或者非61的局域网段都认为是开发模式
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.slice(0, 7) === '192.168' && hostname !== '192.168.49.61') {
      return true;
    } else {
      return false;
    }
  }
};

/**
 * 获取当前代理数据请求地址前缀
 * @return {String} ?proxy="返回值"
 */
var getProxyPrefix = function getProxyPrefix() {
  var prefix = getUrlQueryValue('proxy') || 'mock'; // 代理前缀
  return prefix;
};
/**
 * 手动地址跳转
 * @param {Object} options - $router.push(options)
 */
var jumpTo = function jumpTo(options) {
  var router = getAppStore('router');
  if (typeof options === 'number') {
    router.go(options);
  } else {
    router.push(options);
  }
};

/**
 * sessionStorage操作
 * @param {String} key - key
 * @param {*} value - value，当value为undefined时为getter操作，否则为setter
 * @return {*} value
 */
var sessionStorage = function sessionStorage(key, value) {
  var result;
  if (window.sessionStorage) {
    var _sessionStorage = window.sessionStorage;
    if (value === undefined) {
      var temp = _sessionStorage.getItem(key);
      try {
        var firstChar = temp.slice(0, 1);
        if (firstChar === '{' || firstChar === '[') {
          result = JSON.parse(temp);
        } else {
          result = temp;
        }
      } catch (evt) {
        result = temp;
      }
    } else {
      if (typeof value === 'string') {
        result = _sessionStorage.setItem(key, value);
      } else {
        result = _sessionStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(value));
      }
    }
  }
  return result;
};

/**
 * localStorage操作
 * 基于 https://github.com/marcuswestin/store.js/ 实现
 * @param {String} key - key
 * @param {*} value - value，当value为undefined时为getter操作，否则为setter
 * @return {*} value
 */
var localStorage = function localStorage(key, value) {
  var result;
  if (value === undefined) {
    // getter
    result = __WEBPACK_IMPORTED_MODULE_12_store___default.a.get(key);
  } else {
    result = __WEBPACK_IMPORTED_MODULE_12_store___default.a.set(key, value);
  }
  return result;
};

// 设置app命名空间占用
var appStore = {
  methods: {}, // 存储不同平台同一方法实现
  data: null, // 业务数据存储
  store: null, // vuex
  router: null // vue-router
};
/**
 * 获取app store
 * @param {String} key - 要获取的key
 * @return {*} value
 */
var getAppStore = function getAppStore(key) {
  return appStore[key];
};

/**
 * 设置app store， Deep merge方式
 * @param {String} key - key
 * @param {*} value - value
 * @return {*} value
 */
var setAppStore = function setAppStore(key, value) {
  appStore[key] = value;
  return value;
};

/**
 * 获取app data
 * @param {String} key - key
 * @return {*} value
 */
var getAppData = function getAppData(key) {
  var appData = getAppStore('data');
  return appData[key];
};

/**
 * 设置app data
 * @param {String} key - key
 * @param {*} value - value
 * @return {*} value
 */
var setAppData = function setAppData(key, value) {
  var appData = getAppStore('data');
  var newValue;
  if (Object.prototype.toString.call(appData[key]) === '[object Object]' && Object.prototype.toString.call(value) === '[object Object]') {
    newValue = __WEBPACK_IMPORTED_MODULE_8_lodash_merge___default()({}, appData[key], value);
  } else if (Object.prototype.toString.call(appData[key]) === '[object Array]' && Object.prototype.toString.call(value) === '[object Array]') {
    newValue = appData[key].concat(value);
  } else {
    newValue = value;
  }
  appData[key] = newValue;
  setAppStore('data', appData);
  return newValue;
};
/**
 * 清除app data
 * @param {String} key - key
 * @return {*} value
 */
var removeAppData = function removeAppData(key) {
  var appData = getAppStore('data');
  var value = appData[key];
  delete appData[key];
  setAppStore('data', appData);
  return value;
};
/**
 * 生成唯一id
 * @return {String} uuid
 */
var generateID = function generateID() {
  return 'x' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

/**
 * 自定义log屏幕打印
 * @param {String} message - log message
 * @param {String} [pattern = 'append'] - 信息显示方式：append（追加到上一条后面）; clear（先清屏）
 */
var log = function log(message, pattern) {
  pattern = pattern || 'append';
  var logDom = document.getElementById('app-log');
  var bodyDom = null;
  var closeHandlerDom = null;
  if (!logDom) {
    logDom = document.createElement('div');
    bodyDom = document.createElement('div');
    logDom.id = 'app-log';
    bodyDom.className = 'log-body';
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(logDom.style, {
      display: 'none',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '80%',
      'margin-left': '10%',
      // 'padding-top': '16px',
      'z-index': '100000',
      background: 'white',
      border: '1px solid #cccccc',
      'box-shadow': '0px 4px 8px #444444',
      'font-size': '16px'
    });
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(bodyDom.style, {
      overflow: 'auto',
      'max-height': '300px'
    });
    closeHandlerDom = document.createElement('span');
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(closeHandlerDom.style, {
      position: 'absolute',
      top: '2px',
      right: '16px',
      cursor: 'pointer',
      'font-size': '1.5em',
      'line-height': '1em'
    });
    closeHandlerDom.addEventListener('click', function () {
      logDom.style.display = 'none';
    });
    closeHandlerDom.innerHTML = '&times;';

    logDom.appendChild(bodyDom);
    document.body.appendChild(logDom);
    logDom.appendChild(closeHandlerDom);
  } else {
    bodyDom = logDom.querySelector('.log-body');
  }
  logDom.style.display = 'block';
  var messageDom = document.createElement('p');
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(messageDom.style, {
    'border-bottom': '1px solid #444444',
    'padding': '4px 8px'
  });
  messageDom.innerHTML = message;
  if (pattern === 'clear') {
    logDom.innerHTML = '';
  }
  bodyDom.appendChild(messageDom);
};

/**
 * 获取window scrollTop
 * @return {Number} scrollTop值
 */
var getWindowScrollTop = function getWindowScrollTop() {
  return document.body.scrollTop + document.documentElement.scrollTop;
};

/**
 * 回到顶部
 */
var gotoWinTop = function gotoWinTop() {
  window.scrollTo(0, 0);
};
/**
 * 异步加载js
 * @param {(String|String[])} deps - 要加载的js列表
 * @param {Function} callback - 加载后回调
 */
var asyncLoadJs = function () {
  var store = []; // 存储加载后的依赖JS库信息
  return function (deps, callback) {
    // TODO: 考虑Async机制
    deps = [].concat(deps);
    run( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var dep, flag;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              dep = deps.shift();
              flag = true;

            case 2:
              if (!(dep && flag)) {
                _context4.next = 9;
                break;
              }

              _context4.next = 5;
              return create(dep);

            case 5:
              flag = _context4.sent;

              dep = deps.shift();
              _context4.next = 2;
              break;

            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }), callback);
    /**
     * 执行器
     * @param  {*}   genFn
     * @param  {*} callback
     * @return {*}
     */
    function run(genFn, callback) {
      var gen = genFn();

      function next(data) {
        var r = gen.next(data);
        if (r.done) {
          callback && callback(true);
          return;
        }
        r.value.then(function (data) {
          next(data);
        }).catch(function (data) {
          next(false);
          callback && callback(false, data);
        });
      }
      next();
    }
    /**
     * 异步按序执行，返回一个Promise对象
     * @param  {*} url
     * @return {*}
     */
    function create(url) {
      if (url.slice(0, 1) !== '/' && url.slice(0, 4) !== 'http') {
        url = BASE_PATH + url;
      }
      var data = store.find(function (itemData) {
        return itemData.url === url;
      });
      var p;
      if (!data) {
        p = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var scriptDom = document.createElement('script');
          scriptDom.src = url;
          scriptDom.onload = scriptDom.onreadystatechange = function () {
            if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
              this.onload = this.onreadystatechange = null;
              // 都成功执行回调
              resolve(url);
            }
          };
          scriptDom.onerror = function () {
            reject(url);
          };
          document.getElementsByTagName('head')[0].appendChild(scriptDom);
        });
        store.push({
          url: url,
          promise: p
        });
      } else {
        p = data.promise;
      }
      return p;
    }
  };
}();

/**
 * 异步加载css
 * @param {(String|String[])} deps - 要加载的js列表
 * @param {Function} callback - 加载后回调
 */
var asyncLoadCss = function () {
  var store = {};
  return function (deps, callback) {
    deps = [].concat(deps);
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(deps.map(function (dep) {
      var url = '';
      if (dep.slice(0, 1) !== '/' && dep.slice(0, 4) !== 'http') {
        url = BASE_PATH + dep;
      } else {
        url = dep;
      }
      var p = store[url];
      if (!p) {
        p = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          var linkDom = document.createElement('link');
          linkDom.rel = 'stylesheet';
          linkDom.type = 'text/css';
          linkDom.href = url;
          document.getElementsByTagName('head')[0].appendChild(linkDom);
          linkDom.onload = function () {
            resolve();
          };
          linkDom.onerror = function () {
            reject();
          };
        });
        store[url] = p;
      }
      return p;
    })).then(function () {
      callback();
    }).catch(function (evt) {
      console.log(evt);
    });
  };
}();
/**
 * 组件创建转换器
 * @param {Function} originComponent - 组件创建器
 */
var vueCtorTransformer = function vueCtorTransformer(originComponent) {
  return function () {
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      var asyncFnCreate = function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
          var param;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_11__hook__["a" /* default */].exe('create@component', {});

                case 2:
                  param = _context5.sent;

                  originComponent(resolve, param);

                case 4:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        return function asyncFnCreate() {
          return _ref5.apply(this, arguments);
        };
      }();

      if (typeof originComponent === 'function') {
        // 只处理返回值是function的情况
        asyncFnCreate();
      } else {
        resolve(originComponent);
      }
    });
  };
};

/**
  * 获得输入框光标位置
  * @param {Element} inputDom - :text/textarea element ref
  * @returns {{text: string, start: number, end: number}}
  */
var getCursorPosition = function getCursorPosition(inputDom) {
  var rangeData = {
    text: '',
    start: 0,
    end: 0
  };
  inputDom.focus(); // 重复设置textarea focus在ie下会导致window.scroll定位错乱，所有保证最多设置一次
  if (inputDom.setSelectionRange) {
    // W3C
    rangeData.start = inputDom.selectionStart;
    rangeData.end = inputDom.selectionEnd;
    rangeData.text = rangeData.start !== rangeData.end ? inputDom.value.substring(rangeData.start, rangeData.end) : '';
  } else if (document.selection) {
    // IE
    var i;
    var oS = document.selection.createRange();
    var oR = document.body.createTextRange();
    oR.moveToElementText(inputDom);
    rangeData.text = oS.text;
    rangeData.bookmark = oS.getBookmark();
    // object.moveStart(sUnit [, iCount])
    // Return Value: Integer that returns the number of units moved.
    for (i = 0; oR.compareEndPoints('StartToStart', oS) < 0 && oS.moveStart('character', -1) !== 0; i++) {
      // Why? You can alert(inputDom.value.length)
      if (inputDom.value.charAt(i) === '\n') {
        i++;
      }
    }
    rangeData.start = i;
    rangeData.end = rangeData.text.length + rangeData.start;
  }
  return rangeData;
};
/**
* 设置输入框光标位置
* @param {Element} inputDom - :text/textarea element ref
* @param rangeData
*/
var setCursorPosition = function setCursorPosition(inputDom, rangeData) {
  var start, end;
  if (!rangeData) {
    alert('必须定义光标位置');
    return false;
  }
  start = rangeData.start;
  end = rangeData.end;

  if (inputDom.setSelectionRange) {
    // W3C
    inputDom.focus(); // 重复设置textarea focus在ie下会导致window.scroll定位错乱，所有保证最多设置一次
    inputDom.setSelectionRange(start, end);
  } else if (inputDom.createTextRange) {
    // IE
    var oR = inputDom.createTextRange();

    // Fix IE from counting the newline characters as two seperate characters
    var breakPos, i;
    // 设置断点位置
    breakPos = start;
    for (i = 0; i < breakPos; i++) {
      if (inputDom.value.charAt(i).search(/[\r\n]/) !== -1) {
        start = start - 0.5;
      }
    }
    // 设置断点位置
    breakPos = end;
    for (i = 0; i < breakPos; i++) {
      if (inputDom.value.charAt(i).search(/[\r\n]/) !== -1) {
        end = end - 0.5;
      }
    }

    oR.moveEnd('textedit', -1);
    oR.moveStart('character', start);
    oR.moveEnd('character', end - start);
    oR.select();
  }
};
/**
 * 将内容追加到光标的位置，并保持光标位置不动
 * @param {Element} inputDom - :text/textarea element ref
 * @param text
 */
var appendTextAtCursor = function appendTextAtCursor(inputDom, text) {
  var val = inputDom.value;
  var rangeData = getCursorPosition(inputDom);
  inputDom.value = val.slice(0, rangeData.start) + text + val.slice(rangeData.end);
  // 重设光标位置
  setCursorPosition(inputDom, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(rangeData, {
    start: rangeData.start + text.length,
    end: rangeData.start + text.length
  }));
};
/**
 * 焦点至于输入框最后
 * @param {Element} inputDom - :text/textarea element ref
 */
var focusAtLast = function focusAtLast(inputDom) {
  var val = inputDom.value;
  setCursorPosition(inputDom, {
    start: val.length,
    end: val.length
  });
};

/***/ }),

/***/ "5O2V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_upperFirst__ = __webpack_require__("xdPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_camelCase__ = __webpack_require__("NRb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge__ = __webpack_require__("HN2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_app_store__ = __webpack_require__("NowG");



 /**
                                    * 基于vuex的状态管理仓库
                                    */



var state = function state() {
  return {
    activePage: null, // 存储当前激活page
    activePageName: '', // 存储当前激活page Name
    cachePages: [], // 保存被缓存的page name
    onlyPage: false, // page是否独占整个页面
    pageTransitionName: 'opacity', // 默认opacity效果
    fromRoute: null, // 存储上一个路由信息
    route: null, // 存储当前路由信息
    appData: null // 存储app级别数据
  };
};
var mutations = {
  pageChange: function pageChange(state, activePage) {
    state.activePage = activePage;
  },
  pageNameChange: function pageNameChange(state, activePageName) {
    state.activePageName = activePageName;
  },
  cachePageAdd: function cachePageAdd(state, pageName) {
    var cachePages = state.cachePages;
    var pageNames = [].concat(pageName);
    pageNames.forEach(function (pageName) {
      pageName = __WEBPACK_IMPORTED_MODULE_1_lodash_upperFirst___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_camelCase___default()(pageName));
      if (!cachePages.some(function (value) {
        return value === pageName;
      })) {
        cachePages.push(pageName);
      }
    });
  },
  cachePageRemove: function cachePageRemove(state, pageName) {
    var cachePages = state.cachePages;
    var pageNames = [].concat(pageName);
    pageNames.forEach(function (pageName) {
      pageName = __WEBPACK_IMPORTED_MODULE_1_lodash_upperFirst___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_camelCase___default()(pageName));
      cachePages = cachePages.filter(function (value) {
        return value !== pageName;
      });
    });
    state.cachePages = cachePages;
  },
  onlyPageChange: function onlyPageChange(state, onlyPage) {
    state.onlyPage = onlyPage;
  },
  pageTransitionNameChange: function pageTransitionNameChange(state, pageTransitionName) {
    state.pageTransitionName = pageTransitionName;
  },
  routeChange: function routeChange(state, route) {
    state.route = route;
  },
  fromRouteChange: function fromRouteChange(state, route) {
    state.fromRoute = route;
  },

  // 突变改变appData
  appDataChange: function appDataChange(state, value) {
    var appData = state.appData;
    state.appData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, appData, value);
  }
};

/**
 * Deep merge default options
 */
function init() {
  return __WEBPACK_IMPORTED_MODULE_3_lodash_merge___default()({
    state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state()),
    getters: {},
    actions: {},
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mutations),
    modules: {}
  }, Object(__WEBPACK_IMPORTED_MODULE_4__src_app_store__["a" /* default */])());
};

/***/ }),

/***/ "7Ytt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Component method proxy mechanism
 */
var Mapping = {};

Mapping.install = function (Vue, options) {
  /**
   * 添加弃用接口
   */
  var addDeprecatedApi = function addDeprecatedApi(options) {
    var ctor = this.constructor;
    options = [].concat(options);
    var deprecatedList = ctor.__deprecated_list__ || [];
    options.forEach(function (option) {
      // 防重复添加
      if (!deprecatedList.some(function (option2) {
        return option2.oldName === option.name && option2.newName === option.newName;
      })) {
        deprecatedList.push({
          oldName: option.oldName,
          newName: option.newName,
          description: option.description
        });
      }
    });
    ctor.__deprecated_list__ = deprecatedList;
  };
  Vue.mixin({
    methods: {
      /**
       * 添加弃用接口
       * @param {{ oldName: string, newName: string, description: string}|[]} options
       */
      $addDeprecatedApi: addDeprecatedApi
    }
  });
  Vue.directive('mapping', {
    // 卸载组件时解绑
    unbind: function unbind(el, binding, vnode, oldVnode) {
      var hostCpt = vnode.context;
      var hostMethodName = binding.arg;
      if (hostMethodName) {
        delete hostCpt[hostMethodName];
        // or set it to undefined
        // hostCpt[hostMethodName] = undefined
      }
    },
    bind: function bind(el, binding, vnode, oldVnode) {
      // something logic ...
      var guestCpt = vnode.componentInstance; // 客
      var hostCpt = vnode.context; // 主
      var hostMethodName = binding.arg; // 主代理方法名
      var modifiers = binding.modifiers;
      var guestMethodName = binding.value; // 客代理方法名
      if (!hostMethodName) {
        hostMethodName = guestMethodName;
      }
      // 对于宿主中已存在的方法强制覆盖不提示
      if (hostCpt[hostMethodName] && !modifiers.w) {
        console.warn(hostMethodName + ' 方法在所属组件上下文中已存在，请确认是开发者主动行为（在测试？）');
      } else {
        hostCpt[hostMethodName] = function () {
          var deprecatedList = guestCpt.constructor.__deprecated_list__ || [];
          var newMethodData = null;

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (deprecatedList.some(function (item) {
            if (item.oldName === guestMethodName) {
              newMethodData = item;
              return true;
            }
          })) {
            console.warn(guestMethodName + ' 方法在被代理组件中已被弃用，请替换为 ' + newMethodData.newName + ' 方法。新方法描述如下：\n' + newMethodData.description);
            return guestCpt[newMethodData.newName].apply(guestCpt, args);
          } else {
            if (!guestCpt[guestMethodName]) {
              console.warn(guestMethodName + ' 方法在被代理组件上下文中不存在，静默返回');
            } else {
              return guestCpt[guestMethodName].apply(guestCpt, args);
            }
          }
        };
      }
    }
  });
};
/* harmony default export */ __webpack_exports__["a"] = (Mapping);

/***/ }),

/***/ "AtR4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten__ = __webpack_require__("rCVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten__);



 /**
                                        * 路由配置文件
                                        */

var RouteModal = function RouteModal(lang) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, RouteModal);

  var homeCom = function homeCom() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "ihZd"));
  };
  var dictCom = function dictCom() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "7uOy"));
  };
  var routes = [{
    name: 'OnlineClaim',
    component: homeCom // OnlineClaim
  }, {
    name: 'Dict',
    component: dictCom // OnlineClaim
  }].map(function (item) {
    return {
      isCache: false,
      permission: 'all',
      route: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        path: '/' + lang + '/' + item.name,
        meta: {
          lang: lang
        }
      }, item)
    };
  });
  return routes;
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var routers = ['zh', 'en', 'polish', 'spanish', 'turkish', 'dutch', 'hungary', 'zhtw', 'ptbr', 'germany', 'french', 'italian'].map(function (item) {
    return new RouteModal(item);
  });
  return [{
    permission: 'all',
    route: {
      path: '/',
      name: '/',
      meta: [],
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "MJTj"));
      }
    }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_flatten___default()(routers)));
});

/***/ }),

/***/ "C1GT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "plus/img/c249d6173581866c6469a329a7a8a5cb.png";

/***/ }),

/***/ "CJvL":
/***/ (function(module, exports) {

module.exports = "<div id=\"app\" :class=\"domClass\">\r\n  <baseHeader v-if=\"notLogin\"></baseHeader>\r\n  <div class=\"app-body\" :class=\"{'h100': !notLogin, 'w1200': notLogin}\">\r\n    <!-- activity component view -->\r\n    <page-transition :name=\"pageTransitionName\">\r\n      <keep-alive :include=\"cachePages\">\r\n        <component :is=\"activePage\" class=\"main-page\"> </component>\r\n      </keep-alive>\r\n    </page-transition>\r\n    <!-- frame component view -->\r\n    <router-view></router-view>\r\n  </div>\r\n  <baseFooter v-if=\"notLogin\"></baseFooter>\r\n</div>\r\n";

/***/ }),

/***/ "E2Ak":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-transition",class:[_vm.onTransition && _vm.name ? ("page-transition-" + _vm.name) : ''],style:(_vm.style)},[_c('transition',{attrs:{"name":_vm.name},on:{"before-enter":_vm.handleBeforeEnter,"after-enter":_vm.handleAfterEnter,"after-leave":_vm.handleAfterLeave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FeBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__("9mmO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__ = __webpack_require__("52Wt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__ = __webpack_require__("TFWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__("MyjO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__ = __webpack_require__("qtRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__ = __webpack_require__("THnP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__ = __webpack_require__("K0JP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__ = __webpack_require__("NfZy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__ = __webpack_require__("dTzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__ = __webpack_require__("+vXH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__ = __webpack_require__("MsuQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__ = __webpack_require__("dSUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__ = __webpack_require__("ZDXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__ = __webpack_require__("V/H1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__ = __webpack_require__("CVR+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__ = __webpack_require__("vmSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__ = __webpack_require__("4ZU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__ = __webpack_require__("yx1U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__ = __webpack_require__("SPtU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__("A52B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__("PuTd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__ = __webpack_require__("dm+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__("JG34");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__ = __webpack_require__("Rw4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__("9mGU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__ = __webpack_require__("bUY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__("mTp7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__ = __webpack_require__("y9m4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__ = __webpack_require__("A0n/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_freeze__ = __webpack_require__("VTn2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_seal__ = __webpack_require__("W/IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__("Y5ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_is_frozen__ = __webpack_require__("WpPb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_sealed__ = __webpack_require__("+yjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_extensible__ = __webpack_require__("gPva");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__("C+4B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__("W4Z6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_keys__ = __webpack_require__("tJwI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__("eC2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_assign__ = __webpack_require__("n12u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_is__ = __webpack_require__("nRs1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__("jrHM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_function_name__ = __webpack_require__("EuXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_string_raw__ = __webpack_require__("F3sI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_from_code_point__ = __webpack_require__("bqOW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_code_point_at__ = __webpack_require__("Racj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_repeat__ = __webpack_require__("tqSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_starts_with__ = __webpack_require__("CvWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_ends_with__ = __webpack_require__("Y1S0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_includes__ = __webpack_require__("Gh7F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_regexp_flags__ = __webpack_require__("pd+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_match__ = __webpack_require__("MfeA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_replace__ = __webpack_require__("VjuZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_split__ = __webpack_require__("mJx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_search__ = __webpack_require__("qwQ3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_array_from__ = __webpack_require__("beEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_of__ = __webpack_require__("xMpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_copy_within__ = __webpack_require__("9vc3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_find__ = __webpack_require__("WpTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find_index__ = __webpack_require__("U6qc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_fill__ = __webpack_require__("No4x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_iterator__ = __webpack_require__("WgSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_number_is_finite__ = __webpack_require__("yuXV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_integer__ = __webpack_require__("XtiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__("A1ng");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_nan__ = __webpack_require__("LG56");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_epsilon__ = __webpack_require__("Stuz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__("aJ2J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__("WiIn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_acosh__ = __webpack_require__("v2lb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_asinh__ = __webpack_require__("7Jvp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_atanh__ = __webpack_require__("lyhN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_cbrt__ = __webpack_require__("kBOG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_clz32__ = __webpack_require__("xONB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_cosh__ = __webpack_require__("LlNE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_expm1__ = __webpack_require__("9xIj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_fround__ = __webpack_require__("m6Yj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_hypot__ = __webpack_require__("wrs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_imul__ = __webpack_require__("Lqg1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_log1p__ = __webpack_require__("pWGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log10__ = __webpack_require__("1ip3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log2__ = __webpack_require__("N4KQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_sign__ = __webpack_require__("Hl+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sinh__ = __webpack_require__("MjHD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_tanh__ = __webpack_require__("SRCy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_trunc__ = __webpack_require__("H0mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es7_array_includes__ = __webpack_require__("gbyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_object_values__ = __webpack_require__("YVn/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_entries__ = __webpack_require__("FKfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__("zmx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_string_pad_start__ = __webpack_require__("smQ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_end__ = __webpack_require__("m8F4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_web_timers__ = __webpack_require__("v8VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_immediate__ = __webpack_require__("dich");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_dom_iterable__ = __webpack_require__("fx22");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_regenerator_runtime_runtime__ = __webpack_require__("SldL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__deps_env__ = __webpack_require__("m/6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__app__ = __webpack_require__("GF88");
/**
 * 入口文件
 */




































































































new __WEBPACK_IMPORTED_MODULE_96__deps_env__["a" /* Vue */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_97__app__["a" /* default */]);
  }
});

/***/ }),

/***/ "GF88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_merge__ = __webpack_require__("HN2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deps_env__ = __webpack_require__("m/6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deps_sitmap__ = __webpack_require__("gatZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__deps_store__ = __webpack_require__("5O2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deps_hook__ = __webpack_require__("IrkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__deps_utils__ = __webpack_require__("4yfQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_transition__ = __webpack_require__("iIy3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deps_debug__ = __webpack_require__("m1cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_app_index__ = __webpack_require__("evzl");





/**
 * App component
 */








 // 挂载业务框架

/* harmony default export */ __webpack_exports__["a"] = (function (resolve) {
  /**
   * 骨架预设值
   */
  var create = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var store, _ref2, appData, _ref2$routerOptions, routerOptions, lClass, sitmap, router, appOptions;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 初始化debug
              Object(__WEBPACK_IMPORTED_MODULE_11__deps_debug__["a" /* default */])();
              // 初始化store
              store = new __WEBPACK_IMPORTED_MODULE_5__deps_env__["c" /* Vuex */].Store(Object(__WEBPACK_IMPORTED_MODULE_7__deps_store__["a" /* init */])());
              // 设置全局引用

              Object(__WEBPACK_IMPORTED_MODULE_9__deps_utils__["h" /* setAppStore */])('store', store);
              Object(__WEBPACK_IMPORTED_MODULE_9__deps_utils__["h" /* setAppStore */])('data', window.__data__ || {});
              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_8__deps_hook__["a" /* default */].exe('prepare@app', { // prepare可能会用到store引用
                store: store
              });

            case 6:
              _ref2 = _context.sent;
              appData = _ref2.appData;
              _ref2$routerOptions = _ref2.routerOptions;
              routerOptions = _ref2$routerOptions === undefined ? {} : _ref2$routerOptions;
              lClass = location.hash.split('/')[1];
              // 设置全局引用

              Object(__WEBPACK_IMPORTED_MODULE_9__deps_utils__["h" /* setAppStore */])('data', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__deps_utils__["c" /* getAppStore */])('data'), appData));
              // 设置vuex state存储
              store.commit('appDataChange', appData);
              // 初始化router
              _context.next = 15;
              return Object(__WEBPACK_IMPORTED_MODULE_6__deps_sitmap__["a" /* init */])();

            case 15:
              sitmap = _context.sent;
              router = new __WEBPACK_IMPORTED_MODULE_5__deps_env__["b" /* VueRouter */](__WEBPACK_IMPORTED_MODULE_4_lodash_merge___default()({
                routes: sitmap.routes.filter(function (item) {
                  return item.meta && item.meta.lang === lClass || item.name === '/';
                })
              }, routerOptions));
              // 设置全局引用

              Object(__WEBPACK_IMPORTED_MODULE_9__deps_utils__["h" /* setAppStore */])('router', router);
              // app hook
              _context.next = 20;
              return __WEBPACK_IMPORTED_MODULE_8__deps_hook__["a" /* default */].exe('create@app', {
                store: store,
                router: router,
                sitmap: sitmap,
                appData: appData
              });

            case 20:
              appOptions = _context.sent;

              // 创建app应用
              resolve(__WEBPACK_IMPORTED_MODULE_4_lodash_merge___default()({
                name: 'App',
                template: '<div id="app" :class="domClass">\n        <div class="app-body">\n          <!-- activity component view -->\n          <page-transition :name="pageTransitionName">\n            <keep-alive :include="cachePages">\n              <component :is="activePage">\n                <!-- inactive components will be cached! -->\n              </component>\n            </keep-alive>\n          </page-transition>\n          <!-- frame component view -->\n          <router-view></router-view>\n        </div>\n      </div>',
                router: router,
                store: store,
                computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5__deps_env__["d" /* mapState */])({
                  activePage: function activePage(state) {
                    return state.activePage;
                  },
                  pageTransitionName: function pageTransitionName(state) {
                    return state.pageTransitionName;
                  },
                  domClass: function domClass(state) {
                    var _ref3;

                    return _ref3 = {
                      'app': true,
                      'app-only-page': state.onlyPage,
                      'en': lClass === 'en'
                    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, store.state.activePageName.replace(lClass + '-', '') + '__scope', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, 'isPhone', document.body.clientWidth < 900), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref3, 'isPC', document.body.clientWidth > 900), _ref3;
                  },
                  cachePages: function cachePages(state) {
                    var cachePages = state.cachePages;
                    if (!cachePages.length) {
                      return '_'; // 占位，否则include为空默认缓存全部，WTF
                    }
                    return cachePages.join(',');
                    // return new RegExp('(?!' + cachePages.map(pageName => '.*' + pageName).join('|') + ')^.*$');
                  }
                })),
                components: {
                  PageTransition: __WEBPACK_IMPORTED_MODULE_10__page_transition__["a" /* default */]
                }
              }, appOptions || {}));

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function create() {
      return _ref.apply(this, arguments);
    };
  }();

  create();
});

/***/ }),

/***/ "IrkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



/**
 * 异步执行handler
 * @param {string} name
 * @param {Array} args
 */
var exe = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(name) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var handlers, result, i, handler, value, isPromise, then, catch_;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            handlers = store[name] || [];
            result = [];
            // handlers.forEach(async (handler) => {

            i = 0;

          case 3:
            if (!(i < handlers.length)) {
              _context.next = 20;
              break;
            }

            handler = handlers[i];
            value = handler.apply(this, args);
            isPromise = true;
            // 判断是否为promise

            try {
              then = value.then;
              catch_ = value.catch;

              if (Object.prototype.toString.call(then) === '[object Function]' && Object.prototype.toString.call(catch_) === '[object Function]') {
                isPromise = true;
              }
            } catch (evt) {}

            if (!isPromise) {
              _context.next = 16;
              break;
            }

            _context.t0 = result;
            _context.next = 12;
            return value;

          case 12:
            _context.t1 = _context.sent;

            _context.t0.push.call(_context.t0, _context.t1);

            _context.next = 17;
            break;

          case 16:
            result.push(value);

          case 17:
            i++;
            _context.next = 3;
            break;

          case 20:
            if (!result.length) {
              result = null;
            } else if (result.length === 1) {
              result = result[0];
            }
            return _context.abrupt('return', result);

          case 22:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function exe(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * hook机制
 * 用于app业务与project template关联
 */
var store = {}; // 存储所有挂钩的hook
function hook(name, handler) {
  var handlers = store[name] || [];
  if (!handlers.some(function (item) {
    // 不重复添加
    return item === handler;
  })) {
    handlers.push(handler);
  }
  store[name] = handlers;
  // 返回dispose handler
  return function () {
    store[name] = handlers.filter(function (item) {
      return item !== handler;
    });
  };
}
hook.exe = exe; // 暴露引用
/* harmony default export */ __webpack_exports__["a"] = (hook);

/***/ }),

/***/ "Kfq4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "plus/img/053b2cc9ad87e9407f2a46704bf7e70a.png";

/***/ }),

/***/ "KiDm":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAADG0lEQVRIS72WS2gUQRCG/+qdBYMaIWoOIoJKTKZ7ICAxF8UHnpSo4EnU6EVQFBQURPGBqEFRFAUVFU8i6DERNeDBiBoEjYE8eiZrDgHx4oOAQXNwd6ak40zYbDK7Q5Ttyxymq76u6vqri5Bw9fT0zEylUo1EtAxAVWg2zMwffd9/V19f/yuJKyq1yfO8piAI9gNYC6AbgBZCfDd2QRDMA6AALAfwUghxy7btJ8V8xgIzmcyKXC53BUAlEV1l5idKqeGpnGmtq4ioiZkPAxixLOtIbW3t+6n2TgnUWu8jotMAjtm2/YCIglKZMP+ZWXietxPARWY+q5S6XWg3Cei67iUAG4QQm+vq6oaSgAr39Pb2LrEsqw1Au5TyaP7/CcAwsgPpdHplTU3NyHRgkc3g4GBlNpvtZOab+ZGOA82d+b7fJoRYOd3ICg84MDCwOAiCzlQqtSW603Gg1voVEd2TUt7/l8gKbV3X3cXMe5RSq82/MWBY+uellMuTFkjSQ5lCcl23Wwhx0khmDKi1fkZEj6YTHTNbRJQrdoAwym1KqY1kOohlWd8ALIzTmed5a3zfH3Ic51PkuKOjY0Z1dfVDAJtMkgDcIKIvUsrWQrjRKYDPuVxuPvX3968jonNKqVVxp/Q87wwz7yKiHbZtvw2zchDA9ciGmXNCiAtSSqPfSUtr/YaZT5HWeq9pTUop851ymQiDIHgxdulE7QBambkJwJY8g5/MPNdxnN8xwDumNRrgcSHELNu2T8QBXddtZuaLABYUuatBpZRp7HGHbgmC4GciYF9f31Ii+kBEc+IcMvN9x3F2JwGWTKlx4rruIWa+DCAd43S1Uup1HFBr/TelSYomBDrM/BTAokKnRPRQSrm9mDTGiyaJLIyjrq6udEVFRTOAawBmR86J6Hk2m91a7AGeIIuwxIsKP5PJrPd9vwVAIzNH7bAfwE0p5d1S3WmC8A0waWsLH9q5o6OjXxsaGn4US2GePie3tjDK8jVvAyz78xRGaUaL8jzAUc7/x4gRPryPS44YEbSsQ1QELeuYmF/uZRuECzX2v0b9P/wo8F6SJ6OjAAAAAElFTkSuQmCC"

/***/ }),

/***/ "NXh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_camelCase__ = __webpack_require__("NRb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_camelCase__);




 /**
                                            * Like angular Service ? 蛤
                                            * Singleton process whole app scope
                                            * 前期只当成state container使用
                                            * @author 13
                                            */

var Service = {};
var serviceStore = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
var SERVICE_KEY_PREFIX = 'service';

Service.install = function (Vue) {
  // const extend = Vue.extend
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var _this = this;

      var getServices = function getServices() {
        var $options = _this.$options;
        var services = null;
        if (Array.isArray($options.services)) {
          services = $options.services.reduce(function (pv, cv, ci) {
            var key = cv.name ? __WEBPACK_IMPORTED_MODULE_4_lodash_camelCase___default()(cv.name) : SERVICE_KEY_PREFIX + ci;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, pv, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, cv));
          }, {});
        } else {
          services = $options.services;
        }
        return services;
      };
      var services = getServices();
      if (services) {
        this._services = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(services).map(function (key) {
          var Ctor = services[key];
          var serviceIns = serviceStore.get(Ctor) || new Vue(Ctor);
          // 重新指回
          serviceStore.set(Ctor, serviceIns);
          // 暴露给this引用
          _this[key] = serviceIns;
          return key;
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      var _this2 = this;

      var services = this._services;
      if (services) {
        services.forEach(function (key) {
          delete _this2[key]; // 释放索引
        });
        this._services = null;
      }
    }
  });
};
/* harmony default export */ __webpack_exports__["a"] = (Service);

/***/ }),

/***/ "NowG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    state: {},
    getters: {},
    actions: {},
    mutations: {}
  };
});;

/***/ }),

/***/ "WQ41":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAADfElEQVRIS8VWTYgcVRD+6nVvFJQcBkWIf2hct/tVx4WAUcgSNUEwskT25iF6CijxFjFE1AgxSlAUL4pCTjEHbyGyGFASjGxAVljY3ak3vU5AUCMGQxaCAZ2deSUv9CyTSWdmXZaxLw39qurrqlffV0VY4TM7O3tbFEVbiOhhAJXC7bKq/tRqtaZHR0evriQU9TOq1Wrj3vu9AJ4EMANAjDGXgp/3/g4ADGAzgO+MMZ+maTrZK+ZNARcWFh5tNpsfAlhPRB+p6iQzXy4LJiIVIhpX1X0ArsRx/OrIyMiPZbalgCLyMhEdBHAgTdPjROT7VSKcq6qp1Wq7ARxR1UPM/Fm33w2Azrn3Aew0xuxKkuTnlQB128zNzT0Yx/FJAKestfs7z68DLDJ7ZWhoaOvw8PCV1YC1fer1+vqlpaVzqvpJZ6bLgOHOWq3WSWPM1tVm1v2DeZ4/4L0/F0XRc+07XQYUke+J6Ki19lin4/z8/MYoig6qaujSuwCsA9D2UwANIroI4Gxxb+c7/Z1zL6rqHmbeFr5fcyxa/7C1dnNng9Tr9Y2NRmOaiKpEdFxVfwfwj6oGIBBR8L+FiDZ470OzbAKwhZmXQUMjOedmjDFvBspcAxSRr4noy+7snHPHVPV+a+1TvTrVObc/juNvGo3Gx0T0KzO/UJLl88z8LAUFieP4TwD3dPNMRH4hokPW2qPtANVqdcwYM14Qf7JSqcwsLi7+oarvAbgU6MTM93UCBp4C+K3ZbN5J1Wo1/P07zDzWfeki8jeACWY+Fc6cc0cAvAbgh8L2cQAfeO8PM/NV59wzAE4w860lsaZU9S0SkZeCNDFzeF/3iEgg/NPMfLrI7Kz3fiLLsq+CYZ7nu7z3J7z3T2RZNiUiOwB8y8ymJNbnQRoD4OvGmNvTNH2jxEijKNqRJMmZkJ2qjnVXQkSmiGjKWnsgz/PtrVbrNDPfICi1Wu1d7/1f/wvgfyqpMWYiSZLVl3QtmiaUs6DXzr5N048WQT2yLLspLUKzdFBmT19a9CK+iHyhqvcy8/Z+Iyooioic6Uv8XtImIg8BmFbVOQBhLl4I2hlGX5FV6MZ1qno3gN1E9AgRPWatrbezLpW2IstS8S5A3yaibaq6NuIdAAc+noosw2oxmAHcrvlarBjF4A1c7b1itEEHukS1QQe6JnaK+MAW4e7JsVar/r/Pb5NttXNfuwAAAABJRU5ErkJggg=="

/***/ }),

/***/ "YSo9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      onTransition: false,
      style: {}
    };
  },

  watch: {},
  destroyed: function destroyed() {},

  methods: {
    handleBeforeEnter: function handleBeforeEnter() {
      this.onTransition = true;
    },

    // handleEnter(el, done) {
    //   done();
    // },
    handleAfterEnter: function handleAfterEnter() {
      this.onTransition = false;
    },
    handleBeforeLeave: function handleBeforeLeave() {
      // let value = {};
      // const name = this.name;
      // if (name === 'flip') {
      //   console.log(11111);
      //   const winScrollTop = document.body.scrollTop + document.documentElement.scrollTop; // 记录位置
      //   value['perspective-origin'] = '50% ' + winScrollTop + 'px';
      //   this.style = value;
      // }
    },
    handleAfterLeave: function handleAfterLeave() {
      // this.onTransition = false;
    },
    handleLeave: function handleLeave(el, done) {
      // done();
      // const name = this.name;
      // if (name === 'perspective-left') {
      //   Velocity(el, {
      //     opacity: [0, 1],
      //     transformPerspective: [2000, 2000],
      //     transformOriginX: [0, 0],
      //     transformOriginY: [0, 0],
      //     rotateY: -180
      //   }, {
      //     duration: 12960,
      //     complete: () => {
      //       Velocity.animate(el, {
      //         transformPerspective: 0,
      //         transformOriginX: '50%',
      //         transformOriginY: '50%',
      //         rotateY: 0
      //       }, {
      //         duration: 0,
      //         queue: false,
      //         complete: done
      //       });
      //     }
      //   });
      // } else {
      //   done();
      // }
    }
  }
});

/***/ }),

/***/ "bl+r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "evzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deps_env__ = __webpack_require__("m/6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deps_hook__ = __webpack_require__("IrkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("0khR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_html__ = __webpack_require__("CJvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__template_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules__ = __webpack_require__("DZVs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__widgets_i18n__ = __webpack_require__("kRUa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deps_utils__ = __webpack_require__("fpVW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__element_variables_scss__ = __webpack_require__("2i04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("ug5o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__deps_directive__ = __webpack_require__("K6Cp");

/**
 * App hook
 */











__WEBPACK_IMPORTED_MODULE_1__deps_env__["a" /* Vue */].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, {
  i18n: function i18n(key, value) {
    return __WEBPACK_IMPORTED_MODULE_7__widgets_i18n__["a" /* default */].t(key, value);
  }
});
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_6__modules__["a" /* default */]).forEach(function (k) {
  return __WEBPACK_IMPORTED_MODULE_1__deps_env__["a" /* Vue */].component(k, __WEBPACK_IMPORTED_MODULE_6__modules__["a" /* default */][k]);
});
__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */]).forEach(function (k) {
  __WEBPACK_IMPORTED_MODULE_1__deps_env__["a" /* Vue */].prototype['$' + k] = __WEBPACK_IMPORTED_MODULE_3__util__["a" /* default */][k];
});

// 数据挂钩
Object(__WEBPACK_IMPORTED_MODULE_2__deps_hook__["a" /* default */])('prepare@app', function () {
  return {
    appData: null,
    routerOptions: {}
  };
});
Object(__WEBPACK_IMPORTED_MODULE_2__deps_hook__["a" /* default */])('switch@route', function (options) {
  window.isLogin = sessionStorage.getItem('userData');
  var userData = JSON.parse(sessionStorage.getItem('userData'));
  var token = userData && userData.token ? userData.token : '';
  Object(__WEBPACK_IMPORTED_MODULE_8__deps_utils__["d" /* setAppData */])('$defaultRequestHeader', { Authentication: token });
  Object(__WEBPACK_IMPORTED_MODULE_8__deps_utils__["d" /* setAppData */])('$defaultRequestHeader', { 'Accept-Language': location.hash.split('/')[1] || 'en' });
  Object(__WEBPACK_IMPORTED_MODULE_8__deps_utils__["d" /* setAppData */])('$defaultRequestHeader', { 'user-type': 2 });
});
Object(__WEBPACK_IMPORTED_MODULE_2__deps_hook__["a" /* default */])('request@ajax', function (options) {
  window.isLogin = sessionStorage.getItem('userData');
  var userData = JSON.parse(sessionStorage.getItem('userData'));
  var token = userData && userData.token ? userData.token : '';
  Object(__WEBPACK_IMPORTED_MODULE_8__deps_utils__["d" /* setAppData */])('$defaultRequestHeader', { Authentication: token });
  Object(__WEBPACK_IMPORTED_MODULE_8__deps_utils__["d" /* setAppData */])('$defaultRequestHeader', { 'Accept-Language': location.hash.split('/')[1] || 'en' });
  Object(__WEBPACK_IMPORTED_MODULE_8__deps_utils__["d" /* setAppData */])('$defaultRequestHeader', { 'user-type': 2 });
});
// App component挂钩，将component configs传递给resolve完成初始化
Object(__WEBPACK_IMPORTED_MODULE_2__deps_hook__["a" /* default */])('create@app', function (options) {
  // Set default request params
  return {
    i18n: __WEBPACK_IMPORTED_MODULE_7__widgets_i18n__["a" /* default */],
    template: __WEBPACK_IMPORTED_MODULE_4__template_html___default.a,
    computed: {
      isCollapse: function isCollapse() {
        return this.$store.state.isCollapse;
      },
      notLogin: function notLogin() {
        var routeNames = ['login', 'regit', 'forget'].includes(this.$route.name);
        return !routeNames;
      }
    }
  };
});

/***/ }),

/***/ "ewXq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAADAUlEQVRIS71WXYhNURT+1r7nPvjJg0x5QI0aM2evqalpeCFRqJF4UopIKTIvQvKvMCV/T4iSJElJmUkkL5rGC5OaafY5M2ZKSfNCMxKZZs7dS3ucq5nr3F+65+U87L3Wt9fa3/ftRSjx6+3tnZNKpVYQ0TIA8+OwURF5n8lk3jQ1Nf0oJRUV2xSG4SZr7X4AawC8A2CUUl9cnLV2AQAG0AzglVLqhu/7TwvlzAs4ODi4PIqiKwDmEdFVEXnKzKNJyYwx84lok4gcBPDN87xD9fX1b5P2JgIaY/YR0WkAR33fv09Etlgn3LqIqDAMdwC4ICJnmflmbtxfgEEQXATQqpTa3NDQ8KEUoNw9fX19Sz3P6wDwXGt9ZPr6DMC4srZ0Or2yrq7uWyVg2ZihoaF5k5OTr0Xk+vRK/wC6O8tkMh1KqZWVVpZ7wIGBgVpr7etUKrUle6d/AI0xXUR0W2t9L6mynp6edEtLy2S5VQdBsFNE9jDzahc7BRhT/7zWujmXICMjI7PHxsYc45aISGtjY2N3OaCOSEEQvFNKnXSSmQI0xjwjoodJ1Q0PDy+emJj4ICIpImrTWt8oB9DtjavcxswbyTmI53mfASzKp7MgCNZZa2vHx8fvVtJWp1MAn6IoqqH+/v61RHSOmVflO7kx5jARObd5ZK197PSplPooIm8AHACQJqIHWutLBXJ0i8gpMsbsddbEzO6f+Blj2gEcJ6I7ItIJ4AkA552zAKhsEBFt0Fq/zONGt5w1OsBjSqm5vu+fKBMQSqkzjvYA7gNYCOAqMx9KyhOGYbu19vu/AP7UWs91rDbG3AGwm4juaa13FQOstKVfmLkmZuE1EWkD8ICZtxdsaYmkSbrDcgF/k6YUWeQhTcmAM2RRTPhxy5wkdgPojKKoy/O8yyLylZnXx+vuRdgqIi+Y+WRuS2cIv5i1lesqufsTrS2usqB5VwqcaN4uWdWfp7hKN1pU5wHOtux/jBjxw+sssPCIkQWt6hCVBa3qmDidkVUbhHNl8L9G/V/d+iZti1JmOgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "gatZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray__ = __webpack_require__("NGEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_mergeWith__ = __webpack_require__("zMR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_mergeWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_mergeWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_merge__ = __webpack_require__("HN2V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_kebabCase__ = __webpack_require__("Ex7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_upperFirst__ = __webpack_require__("xdPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_camelCase__ = __webpack_require__("NRb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__env__ = __webpack_require__("m/6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hook__ = __webpack_require__("IrkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__("4yfQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_raf__ = __webpack_require__("ommR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_app_sitmap__ = __webpack_require__("AtR4");













var extractRoutes = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(records, all) {
    var _this = this;

    var store, router, routes, _loop, i;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            store = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* getAppStore */])('store'); // 获取保存的vuex store引用

            router = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* getAppStore */])('router'); // 获取路由引用

            routes = [];
            // records.forEach(async (record) => {

            _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop(i) {
              var record, route, onlyPage, pageTransitionName, isCache, deepClean, pageName, validData, documentTitle, channel, channelNormalized, hasMainKey, channelKeys, pageComponent, originComponent, ActivityComponent, activityComponentFactory, WrapperComponent, handleRouteChangeTo, handleRouteChangeFrom, FragmentComponents, defaultFragmentMixins, defaultFragment, originFragment, childrenRoutes, FragmentComponent, FragmentProxyComponent, _childrenRoutes;

              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      record = records[i];

                      if (!record.route) {
                        _context3.next = 62;
                        break;
                      }

                      route = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, record.route);
                      onlyPage = record.onlyPage;
                      pageTransitionName = record.pageTransitionName || ''; // 页面切换效果，默认opacity

                      isCache = record.isCache; // 是否有缓存标识，目前只控制Activity component部分

                      deepClean = record.deepClean === true; // 设置deepClean为true表示在isCache为false的情况下，执行深度清理，RealComponent将会重新生成

                      pageName = getSemanticPageName(record, all);
                      // 路由访问控制，层层向上继承，严格满足每一层级限制，默认permission约束

                      _context3.next = 10;
                      return getFamilyAccessConditions(record, all);

                    case 10:
                      validData = _context3.sent;

                      // 获取documentTitle设定
                      documentTitle = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["d" /* getUrlQueryValue */])('documentTitle') || ''; // 地址传参为第一优先级

                      if (typeof record.documentTitle === 'undefined') {
                        if (!documentTitle) {
                          // 如果record设定和地址传参都为空，则不设置document title
                          documentTitle = false;
                        }
                      } else {
                        if (!documentTitle) {
                          documentTitle = record.documentTitle;
                        }
                      }

                      // 默认route param以props方式传递
                      if (!validData.isValid) {
                        route.props = validData.props;
                      }
                      // 保存pageName
                      route.meta.pageName = pageName;
                      // 存储页面缓存名称
                      if (isCache !== undefined) {
                        if (isCache) {
                          store.commit('cachePageAdd', pageName);
                        }
                      } else {
                        // 默认带 :/?/# 特殊字符的路由页面会被缓存
                        if (/[?|:|#]+/.test(route.path)) {
                          store.commit('cachePageAdd', pageName);
                          isCache = true;
                        }
                      }
                      // Normalize channel TODO: 只考虑了activity模式，fragement暂不考虑
                      channel = record.channel;
                      channelNormalized = [];

                      if (channel) {
                        if (typeof channel === 'string') {
                          channelNormalized = channelNormalized.concat(channel.split(','));
                        } else if (Array.isArray(channel)) {
                          channelNormalized = channelNormalized.concat(channel);
                        } else {
                          channelNormalized = channel; // 被认为是Object
                        }
                      }
                      hasMainKey = false;

                      if (Array.isArray(channelNormalized)) {
                        channelNormalized = channelNormalized.reduce(function (pv, cv) {
                          if (cv === 'main') {
                            hasMainKey = true;
                          }
                          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, pv, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, cv, cv));
                        }, {});
                      } else {
                        if (channelNormalized['main']) {
                          hasMainKey = true;
                        }
                      }
                      channelKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(channelNormalized);

                      if (channelKeys.length) {
                        if (!hasMainKey) {
                          // 如果没有main key，默认取第一个key为main key
                          channelNormalized['main'] = channelNormalized[channelKeys[0]];
                        }
                      } else {
                        channelNormalized = {};
                      }
                      // 附加page信道
                      channelNormalized['page'] = 'page';
                      // 替换component
                      pageComponent = null;
                      originComponent = validData.isValid ? route.component : function () {
                        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "1OMl"));
                      };
                      ActivityComponent = null;

                      if (route.fragment || route.fragments) {
                        if (!originComponent) {
                          originComponent = function originComponent() {
                            // 有fragment和fragments的情况下如果不设置component，默认设置一个占位
                            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                              resolve({
                                default: {
                                  render: function render() {
                                    return null;
                                  }
                                }
                              });
                            });
                          };
                        }
                      }
                      if (!originComponent) {
                        console.error('缺少route.component设置');
                      }
                      /**
                       * 创建Activity页面组件工厂，可多次创建ActivityComponent
                       */

                      activityComponentFactory = function activityComponentFactory() {
                        return function () {
                          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                            originComponent().then(function (mod) {
                              // 设置页面实现name
                              var asyncFnCreate = function () {
                                var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                                  var param;
                                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                      switch (_context.prev = _context.next) {
                                        case 0:
                                          _context.next = 2;
                                          return __WEBPACK_IMPORTED_MODULE_13__hook__["a" /* default */].exe('create@component', {});

                                        case 2:
                                          param = _context.sent;

                                          exportDefault(resolve, {
                                            name: cptName,
                                            param: param
                                          });

                                        case 4:
                                        case 'end':
                                          return _context.stop();
                                      }
                                    }
                                  }, _callee, this);
                                }));

                                return function asyncFnCreate() {
                                  return _ref2.apply(this, arguments);
                                };
                              }();

                              var exportDefault = mod.default;
                              var cptName = pageName + 'Default';
                              if (typeof exportDefault === 'function') {
                                asyncFnCreate();
                              } else {
                                resolve(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
                                  name: cptName
                                }, exportDefault));
                              }
                            }).catch(function (evt) {
                              // 支付宝第一次扫码可能出现加载失败问题，提示信息后退并刷新
                              console.error(evt);
                              alert('资源请求出现网络传输错误，请后退并重新刷新页面');
                              router.go(-1); // 后退
                              location.reload(); // 重新刷新
                            });
                          });
                        };
                      };

                      ActivityComponent = activityComponentFactory();
                      WrapperComponent = __WEBPACK_IMPORTED_MODULE_12__env__["a" /* Vue */].extend({
                        name: pageName,
                        data: function data() {
                          return {
                            coreRendered: true // 延迟渲染，减少因为切换动画导致页面渲染不出来的可能？(经测试可能是第一次网络传输中断所致，暂不考虑延时)
                          };
                        },
                        created: function created() {
                          // setTimeout(() => {
                          //   this.coreRendered = true;
                          // }, 30);
                        },
                        mounted: function mounted() {
                          var $refs = this.$refs;
                          var handler = __WEBPACK_IMPORTED_MODULE_15_raf___default()(function tick() {
                            if ($refs.index) {
                              __WEBPACK_IMPORTED_MODULE_15_raf___default.a.cancel(handler);
                              pageComponent = $refs.index;
                            } else {
                              handler = __WEBPACK_IMPORTED_MODULE_15_raf___default()(tick);
                            }
                          });
                        },
                        destroyed: function destroyed() {
                          pageComponent = null; // 清理引用
                          if (!isCache && deepClean) {
                            // 深度清理，重新生成Real组件工厂
                            ActivityComponent = activityComponentFactory();
                          }
                        },
                        render: function render(h) {
                          var className = {
                            page: true
                          };
                          className[__WEBPACK_IMPORTED_MODULE_9_lodash_kebabCase___default()(pageName)] = true;
                          var coreRendered = this.coreRendered;
                          return h('div', [coreRendered ? h(ActivityComponent, { // 放到子元素里渲染不会触发重复page transition
                            props: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, validData.props, this.$attr, {
                              channel: channelNormalized
                            }),
                            ref: 'index',
                            class: className
                          }) : h('div', {
                            'class': 'page-loading-tip',
                            style: {
                              textAlign: 'center',
                              paddingTop: '130px'
                            }
                          }, '页面加载中……')]);
                          // return h(ActivityComponent, {
                          //   props: {
                          //     ...validData.props,
                          //     ...this.$attr
                          //   },
                          //   ref: 'index',
                          //   class: className
                          // });
                        }
                      });
                      // 自定义route enter/update 进入行为

                      handleRouteChangeTo = function handleRouteChangeTo(to, from, next) {
                        var exe = function () {
                          var _ref3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                            var result, routeUpdated;
                            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    _context2.next = 2;
                                    return __WEBPACK_IMPORTED_MODULE_13__hook__["a" /* default */].exe('switch@route', {
                                      route: to,
                                      to: to,
                                      from: from,
                                      store: store,
                                      activePage: WrapperComponent,
                                      record: record
                                    });

                                  case 2:
                                    result = _context2.sent;

                                    if (!(typeof result !== 'undefined')) {
                                      _context2.next = 8;
                                      break;
                                    }

                                    result = [].concat(result);

                                    if (!result.some(function (value) {
                                      return value === false;
                                    })) {
                                      _context2.next = 8;
                                      break;
                                    }

                                    next(false);
                                    return _context2.abrupt('return');

                                  case 8:
                                    store.commit('pageChange', WrapperComponent);
                                    store.commit('pageNameChange', __WEBPACK_IMPORTED_MODULE_9_lodash_kebabCase___default()(pageName));
                                    // 是否页面独占浏览器窗口
                                    if (onlyPage === true) {
                                      store.commit('onlyPageChange', true);
                                    } else {
                                      store.commit('onlyPageChange', false);
                                    }
                                    store.commit('pageTransitionNameChange', pageTransitionName);
                                    // 更新路由存储信息
                                    store.commit('routeChange', to);
                                    store.commit('fromRouteChange', from);
                                    if (pageComponent) {
                                      // route update操作
                                      // 调用routeUpdated回调
                                      routeUpdated = pageComponent.$options.routeUpdated;

                                      routeUpdated && routeUpdated.call(pageComponent, to);
                                    }
                                    // 设置页面title
                                    if (documentTitle !== false) {
                                      Object(__WEBPACK_IMPORTED_MODULE_14__utils__["i" /* setDocumentTitle */])(documentTitle);
                                    }
                                    // route向下传递
                                    next();

                                  case 17:
                                  case 'end':
                                    return _context2.stop();
                                }
                              }
                            }, _callee2, this);
                          }));

                          return function exe() {
                            return _ref3.apply(this, arguments);
                          };
                        }();

                        if (to.meta.uid === route.meta.uid) {
                          exe();
                        } else {
                          next();
                        }
                      };
                      // 自定义route update/leave 离开行为


                      handleRouteChangeFrom = function handleRouteChangeFrom(from) {
                        if (from.meta.uid === route.meta.uid) {
                          if (!isCache) {
                            pageComponent = null; // 释放引用
                          }
                        }
                      };
                      // console.log('name', getSemanticPageName(record, all));
                      // 创建Fragment组件，支持activity和fragment两种路由形式


                      FragmentComponents = route.fragments; // 多个fragment自动进入手动管理<route-view />模式，fragment自己创建管理<router-view />
                      // console.log(route);

                      defaultFragmentMixins = {
                        beforeRouteEnter: function beforeRouteEnter(to, from, next) {
                          // next();
                          handleRouteChangeTo(to, from, next);
                        },
                        beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
                          // next();
                          handleRouteChangeFrom(from);
                          handleRouteChangeTo(to, from, next);
                        },
                        beforeRouteLeave: function beforeRouteLeave(to, from, next) {
                          next();
                          handleRouteChangeFrom(from);
                        },
                        mounted: function mounted() {
                          this.$el.className += ' page-fragment ' + __WEBPACK_IMPORTED_MODULE_9_lodash_kebabCase___default()(pageName) + '-default-fragment';
                        },
                        destroyed: function destroyed() {}
                      };

                      if (!(Object.prototype.toString.call(FragmentComponents) === '[object Object]')) {
                        _context3.next = 50;
                        break;
                      }

                      delete route.component; // 删除activity引用
                      defaultFragment = FragmentComponents.default; // 默认view

                      if (!defaultFragment) {
                        console.warn('未提供默认default view，自动创建');
                        defaultFragment = __WEBPACK_IMPORTED_MODULE_8_lodash_merge___default()({
                          template: '<router-view></router-view>'
                        }, defaultFragmentMixins);
                      } else {
                        originFragment = defaultFragment;
                        // 附加activity mixins

                        defaultFragment = function defaultFragment() {
                          return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                            if (validData.isValid) {
                              // 具备权限才渲染原本default组件
                              originFragment().then(function (mod) {
                                resolve(__WEBPACK_IMPORTED_MODULE_7_lodash_mergeWith___default()(mod.default, {
                                  mixins: [defaultFragmentMixins]
                                }, function (target, source) {
                                  // array 走合并
                                  if (__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(target)) {
                                    return target.concat(source);
                                  }
                                }));
                              }).catch(function (evt) {
                                console.error(evt);
                              });
                            } else {
                              resolve(__WEBPACK_IMPORTED_MODULE_8_lodash_merge___default()({
                                template: '<router-view></router-view>'
                              }, defaultFragmentMixins));
                            }
                          });
                        };
                      }
                      FragmentComponents.default = defaultFragment; // 找回索引
                      // 设置common className, default已经被设置过
                      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(FragmentComponents).forEach(function (key) {
                        if (key !== 'default') {
                          var _originFragment = FragmentComponents[key];
                          FragmentComponents[key] = function () {
                            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                              if (validData.isValid) {
                                // 非default component也加入权限控制
                                _originFragment().then(function (mod) {
                                  resolve(__WEBPACK_IMPORTED_MODULE_7_lodash_mergeWith___default()(mod.default, {
                                    mixins: [{
                                      mounted: function mounted() {
                                        this.$el.className += ' page-fragment ' + __WEBPACK_IMPORTED_MODULE_9_lodash_kebabCase___default()(pageName) + '-' + key + '-fragment';
                                      }
                                    }]
                                  }, function (target, source) {
                                    // array 走合并
                                    if (__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(target)) {
                                      return target.concat(source);
                                    }
                                  }));
                                }).catch(function (evt) {
                                  console.error(evt);
                                });
                              } else {
                                resolve({
                                  render: function render() {
                                    return null;
                                  }
                                });
                              }
                            });
                          };
                        }
                      });
                      // 重写components
                      route.components = FragmentComponents;
                      // 下一层

                      if (!(record.children && record.children.length)) {
                        _context3.next = 48;
                        break;
                      }

                      _context3.next = 46;
                      return extractRoutes(record.children, all);

                    case 46:
                      childrenRoutes = _context3.sent;

                      if (childrenRoutes && childrenRoutes.length) {
                        route.children = childrenRoutes;
                      }

                    case 48:
                      _context3.next = 61;
                      break;

                    case 50:
                      FragmentComponent = route.fragment; // 自动fragment模式，此模式限制只存在一个fragment嵌入页

                      FragmentProxyComponent = route.component = __WEBPACK_IMPORTED_MODULE_8_lodash_merge___default()({}, defaultFragmentMixins);

                      if (!(record.children && record.children.length)) {
                        _context3.next = 60;
                        break;
                      }

                      _context3.next = 55;
                      return extractRoutes(record.children, all);

                    case 55:
                      _childrenRoutes = _context3.sent;

                      if (_childrenRoutes && _childrenRoutes.length) {
                        route.children = _childrenRoutes;
                      }
                      // 设置带router-view的template
                      // FragmentProxyComponent.template = '<router-view></router-view>';
                      FragmentProxyComponent.render = function (h) {
                        if (validData.isValid && FragmentComponent) {
                          // 加入权限控制
                          return h('div', [h('router-view'), h(FragmentComponent)]);
                        } else {
                          return h('router-view');
                        }
                      };
                      _context3.next = 61;
                      break;

                    case 60:
                      FragmentProxyComponent.render = function () {
                        return null;
                      };

                    case 61:
                      routes.push(route);

                    case 62:
                    case 'end':
                      return _context3.stop();
                  }
                }
              }, _loop, _this);
            });
            i = 0;

          case 5:
            if (!(i < records.length)) {
              _context4.next = 10;
              break;
            }

            return _context4.delegateYield(_loop(i), 't0', 7);

          case 7:
            i++;
            _context4.next = 5;
            break;

          case 10:
            return _context4.abrupt('return', routes);

          case 11:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee3, this);
  }));

  return function extractRoutes(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var extractNavs = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(records, all) {
    var _this2 = this;

    var navs, _loop2, i;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            navs = [];
            _loop2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _loop2(i) {
              var record, nav, childrenNavs;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _loop2$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      record = records[i];
                      // if (record.navVisible) {

                      _context5.t0 = record.uid;
                      _context5.t1 = record.isCache;
                      _context5.t2 = record.route.meta.pageName;
                      _context5.t3 = record.navText;
                      _context5.t4 = record.navVisible !== false;
                      _context5.t5 = record.breadcrumbVisible !== false;
                      _context5.t6 = !!record.breadcrumbDisabled;
                      _context5.t7 = record.permission;

                      _context5.t8 = record.navLink || record.route && function () {
                        var familyRecords = getFamilyRecords(record, all);
                        return '/' + familyRecords.filter(function (record) {
                          return record.route;
                        }).map(function (record) {
                          return getClearPaths(record.route.path).join('/');
                        }).join('/');
                      }() || '';

                      _context5.next = 12;
                      return getFamilyAccessConditions(record, all);

                    case 12:
                      _context5.t9 = _context5.sent;
                      nav = {
                        uid: _context5.t0,
                        isCache: _context5.t1,
                        pageName: _context5.t2,
                        text: _context5.t3,
                        navVisible: _context5.t4,
                        breadcrumbVisible: _context5.t5,
                        breadcrumbDisabled: _context5.t6,
                        permission: _context5.t7,
                        link: _context5.t8,
                        validData: _context5.t9
                      };

                      // 扩展外链地址
                      if (nav.link.slice(0, 2) === '//') {
                        nav.link = location.origin + '/' + nav.link.slice(2);
                      }

                      if (!(record.children && record.children.length)) {
                        _context5.next = 20;
                        break;
                      }

                      _context5.next = 18;
                      return extractNavs(record.children, all);

                    case 18:
                      childrenNavs = _context5.sent;

                      if (childrenNavs && childrenNavs.length) {
                        nav.children = childrenNavs;
                      }

                    case 20:
                      navs.push(nav);
                      // }

                    case 21:
                    case 'end':
                      return _context5.stop();
                  }
                }
              }, _loop2, _this2);
            });
            i = 0;

          case 3:
            if (!(i < records.length)) {
              _context6.next = 8;
              break;
            }

            return _context6.delegateYield(_loop2(i), 't0', 5);

          case 5:
            i++;
            _context6.next = 3;
            break;

          case 8:
            return _context6.abrupt('return', navs);

          case 9:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee4, this);
  }));

  return function extractNavs(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * 查找record的所有parent记录
 * @param {Object} record
 * @param {Array} records
 */


/**
 * 获取family access conditions
 */
var getFamilyAccessConditions = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(record, records) {
    var store, familyRecords, isValid, props, i, _record, result;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            store = Object(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* getAppStore */])('store'); // 获取保存的vuex store引用

            familyRecords = getFamilyRecords(record, records);
            isValid = true;
            props = {};
            i = 0;

          case 5:
            if (!(i < familyRecords.length)) {
              _context7.next = 16;
              break;
            }

            _record = familyRecords[i];
            _context7.next = 9;
            return __WEBPACK_IMPORTED_MODULE_13__hook__["a" /* default */].exe('validate@route', {
              record: _record,
              store: store
            });

          case 9:
            result = _context7.sent;

            result = result ? [].concat(result) : [];

            if (!result.some(function (item) {
              // 验证中断方式
              if (!item.isValid) {
                isValid = false;
                props = item.props;
                return true;
              }
            })) {
              _context7.next = 13;
              break;
            }

            return _context7.abrupt('break', 16);

          case 13:
            i++;
            _context7.next = 5;
            break;

          case 16:
            return _context7.abrupt('return', {
              isValid: isValid,
              props: props
            });

          case 17:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee5, this);
  }));

  return function getFamilyAccessConditions(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * 路径名变pageName辅助函数
 * @param {string} path
 */


/**
 * 定义网站功能地图和路由配置信息
 * 层层引用，分散管理
 */





// 获取app级别的sitmap配置


function addUid(records) {
  var loop = function loop(records) {
    var baseIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    records.forEach(function (record, index) {
      var uid = (baseIndex !== '' ? baseIndex + '-' + index : index) + '';
      record.uid = uid;
      if (record.route) {
        record.route.uid = uid;
        if (record.route.meta) {
          // meta里存一份
          record.route.meta.uid = uid;
        } else {
          record.route.meta = { uid: uid };
        }
      }
      if (record.children && record.children.length) {
        loop(record.children, uid);
      }
    });
  };
  loop(records);
  return records;
};
;

function getFamilyRecords(record, records) {
  var uids = record.uid.split('-');
  var parentRecords = records;
  return uids.reduce(function (pv, cv) {
    var currentRecord = parentRecords[cv];
    if (currentRecord.children && currentRecord.children.length) {
      parentRecords = currentRecord.children;
    }
    return pv.concat(currentRecord);
  }, []);
}

function getSemanticPageName(record, records) {
  var familyRecords = getFamilyRecords(record, records);
  return 'Page' + __WEBPACK_IMPORTED_MODULE_10_lodash_upperFirst___default()(__WEBPACK_IMPORTED_MODULE_11_lodash_camelCase___default()(familyRecords.filter(function (record) {
    return !!record.route;
  }).map(function (record) {
    return getClearPaths(record.route.path).join('-');
  }).join('-')));
}function getClearPaths(path) {
  var paths = path.split('/');
  // filter掉空和参数字符串
  paths = paths.filter(function (frag, i) {
    if (frag && /^[A-Za-z0-9]+$/.test(frag.charAt(0))) {
      return true;
    }
  });
  return paths;
}

/**
 * 初始化sitmap
 */
var init = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
    var records;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            /* records = [{
              isCache: false, // 是否被缓存
              deepClean: false, // 深度清理
              navText: '', // 导航文字
              navLink: '#', // 导航链接
              navVisible: false, // 导航是否可见
              permission: 'all', // 权限控制，无具备权限将会被筛选掉
              pageTransitionName: 'opacity', // 页面切换效果
              route: {
                path: '/login', // For test
                component: () => import('../../pages/pc/login/index')
              }
            } */
            records = Object(__WEBPACK_IMPORTED_MODULE_16__src_app_sitmap__["a" /* default */])();
            // Add side effect

            addUid(records);
            _context8.next = 4;
            return extractRoutes(records, records);

          case 4:
            _context8.t0 = _context8.sent;
            _context8.next = 7;
            return extractNavs(records, records);

          case 7:
            _context8.t1 = _context8.sent;
            _context8.t2 = records;
            return _context8.abrupt('return', {
              routes: _context8.t0,
              navs: _context8.t1,
              records: _context8.t2
            });

          case 10:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee6, this);
  }));

  return function init() {
    return _ref6.apply(this, arguments);
  };
}();;

/***/ }),

/***/ "iIy3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_transition_vue__ = __webpack_require__("YSo9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54957fe6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_transition_vue__ = __webpack_require__("E2Ak");
function injectStyle (ssrContext) {
  __webpack_require__("bl+r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_transition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54957fe6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_transition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lCU1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "plus/img/1d3b01d0ce7c3884682e24b2f7b9534b.png";

/***/ }),

/***/ "m/6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapState; });
/* unused harmony export createNamespacedHelpers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store__ = __webpack_require__("Y4FN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_plugins_expire__ = __webpack_require__("wwqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_plugins_expire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_store_plugins_expire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_channel__ = __webpack_require__("20p3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_mapping__ = __webpack_require__("7Ytt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_service__ = __webpack_require__("NXh/");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1_vue_router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_vuex__["a"]; });
/* unused harmony reexport clientStore */
/**
 * App环境预设
 */








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__plugins_channel__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__plugins_mapping__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__plugins_service__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var mapMutations = __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapMutations,
    mapGetters = __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapGetters,
    mapActions = __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapActions,
    mapState = __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].mapState,
    createNamespacedHelpers = __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].createNamespacedHelpers;

__WEBPACK_IMPORTED_MODULE_3_store___default.a.addPlugin(__WEBPACK_IMPORTED_MODULE_4_store_plugins_expire___default.a);

// Gobal error handler
window.addEventListener('error', function () {
  if (window.console && window.console.error) {
    window.console.error('Global error', arguments);
  }
});

// 设置app命名空间占用


/***/ }),

/***/ "m1cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("4yfQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hook__ = __webpack_require__("IrkN");
/**
 * debug模式初始化
 * 便于调试查看
 */



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var debugMode = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* localStorage */])('debugMode') || 'off'; // 默认关闭
  // 开启debug模式
  var clicks = [];
  // 注册开启动作
  document.addEventListener('mousedown', function (evt) {
    var clientX = evt.clientX;
    var clientY = evt.clientY;
    if (clientX <= 32 && clientY <= 32) {
      clicks.push(new Date() / 1);
    }
    clicks = clicks.slice(-5); // 取最后五次点击
    // 计算最后一次点击和第一次点击间隔不超过2s，则为开启信号
    if (clicks.length === 5 && clicks[4] - clicks[0] <= 2000) {
      debugMode = 'on';
      // 本地存储标识
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* localStorage */])('debugMode', debugMode);
      // 提示已开启debug提示
      // window.alert('已开启通信错误监测面板');
    }
  });
  // 注册hook
  Object(__WEBPACK_IMPORTED_MODULE_1__hook__["a" /* default */])('response@ajax', function (_ref) {
    var data = _ref.data,
        type = _ref.type;
  });
});;

/***/ }),

/***/ "pda6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAC5ElEQVRIS71WS2gUQRB91TNrYJWoUW9eFGIy08GYiF4iokcl6NWDeBJ/uSmI8RP8I4LeDP5QEA9eI0GvIuaia0LWdE9iDnvxZogSlOhmtkt6mV024ya7xjB97K7Xr6q6XnUR6lyjo6MrHcfZSURbADRFsGlm/lwoFN63t7f/rOcqqmUUBEG3MeYUgD0AhgEoIcSUxRlj1gOQADoBvBFC9HueN7jYnQsSTkxM7AjD8A6ARiK6y8yDUsrpapcppZqIqJuZTwOYcV33TEtLy4dqtlUJlVIniKgPwDnP854TkamVCXvOzCIIgsMAbjHzVSnl/TjuL0Kt9W0A+4QQB1pbW3P1EMVtstnsZtd1BwC89n3/bOX5PMIosp5UKtXV3Nw8sxSyEmZycrJxbm5uiJnvVUZaJrRvVigUBoQQXUuNLO7g+Pj4JmPMkOM4B0tvWiZUSr0lose+7z/7n8jiWK31EWY+KqXcbc+KhFHpX/d9v7PeAqnXKVtIWuthIcRFK5kioVLqFRG9iEeXyWRWp9Pp81ZnzLyOiNLM3ADAKXpLFALIA7Cit01gJJ/P3+zo6Phe6VAU5SEp5X6yHcR13a8ANsZ1prXuZ+aT9UYT2T2UUh6vxFidAvgShuEGGhsb20tE16SUu+IXK6VGAGyL7VtNioWcYOZPbW1tW6vc9Y6ZL5FSynrTGffKArTWUzaVMfBTZv5IRFcAxM+s6TcpZanXlqFKqQe2NVrCXiHEKs/zLlSpsF/Rm5WPiOiR7/vHstnsWsdxLgOwKU9VYPNSSvvO81YQBDeMMT8WJVRK/QawYl6niAhzudya2dnZPmbuidnUJPzXlD4hooztlQDsbxFfi6f0X4uGiArMXJRFtVWzaBKXRR3C72Xm7dEvnyaiBmZ2S8I3xuSJqCh8ALWFb4GJt7YoyuSatyVM/HuKorSjRTIfcKnEl2PEiD7elzVHjBJpokNUiTTRMbGygyQ2CMfb1nKN+n8AeJkFbUmsgo8AAAAASUVORK5CYII="

/***/ }),

/***/ "ug5o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yHtX":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACyklEQVRIS71WPWgUURD+5u2mUlIEbdRGIWb3PblgQAsj/jSKErQ0hWgjKFoIEcT/wh8QRSGFomCjWMQyEhSsRE2jEEjuZvcuKUQQGyVF1Cp7O/LiXricm7u9i9wWt8u9mfne/H0zhIzP5OTkKsdxthPRZgBdidqsiEyXy+WPvb29v7OYokZCYRgOxHF8GsAeABMAWCn1w+rFcbwGgAHQB+CtUuqh7/tj9WwuC1gqlbZFUXQPQCcR3ReRMWPMbJoxZu4iogERGQIw57ruuZ6enk9psqmAzHyKiK4BuOD7/nMiihtFwp6LiArD8CiA2yJy3RjzqFbvH8AgCO4AOKCUOuR53ucsQLUyU1NTm1zXHQXwWmt9vvp8CWDi2ZmOjo7+7u7uuVbAKjozMzOd8/Pz4yLyoNrTRUCbs3K5PKqU6m/Vs9oLFovFjXEcjzuOc7iS00VAZn5HRE+01s+yeJbP53copXJWlohs6L6k6QVBcExEThhjdi3I2p+k9G9qrfuyFAgz22I4WQEgokGt9Ys0QFtIQRBMKKWu2JZZAGTmV0Q0ksU7ZrZ9V0iMTwMoAbhrjHm/XGQSLweNMQfJMojrut8BbFiuz6oNBUFwRERG7H+O43R6nvezUQpsnwL4GkXRWioUCnuJ6IYxZmcjRXue3Pap/TbGNGSqik1m/iAiV4mZbS76jDGLOUkDDsNwt4hcEpF1ALYkxfLGvqMoOpvL5Yr1LszMjy01WsCLSqnVvu9frqdQHcpaOcdx1nue962efhiGt+I4/pUZkJm3AjguIj4R7UuMD4uIGGOGiEiyAmYKacXYCnL4N6RtL5oW2sIyR1NVuqQtmm38VkK6pPGbpbZmAVOpLfEyE3nn83nfcZz9dt5qrYcbkUUqeVulto+nxEu7WrRnAFf12YpXjGTwvmy4YlQRbfuWqApoW9fE6spr2yJcW+7/a9X/A4F66V6touq9AAAAAElFTkSuQmCC"

/***/ })

},["FeBO"]);


// WEBPACK FOOTER //
// plus/js/app-2c2fd8ec37c98a0ac374.js